import React, { useState, useEffect } from "react";
import { Alert, Form, Badge, Nav } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FaPlus,
  FaDownload,
  FaInfoCircle,
  FaMinus,
  FaTimes,
  FaUser,
  FaTicketAlt,
  FaSpinner,
} from "react-icons/fa";
import ExcelJS from 'exceljs';
import ImportModal from "../../Components/ImportModel";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
import { FormField } from "./FormField";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import axios from "axios";
import { localserver } from "../../../api/common";
import ImportAttendeesModal from './ImportAttendeesModal';
const getTaxLabel = (taxType, taxOptions, settingsDetails) => {
  if (taxType !== "Excluding Tax" || !taxOptions || taxOptions.length === 0) {
    return taxType === "Including Tax"
      ? "Incl. tax"
      : taxType === "No Tax"
      ? "No tax"
      : "Excl. tax";
  }

  const taxBreakdown = [];
  if (settingsDetails?.state_is_same === "no") {
    const igstTax = taxOptions.find((tax) => tax.tax_name === "IGST");
    if (igstTax && Number.parseFloat(igstTax.tax_percentage || 0) > 0) {
      taxBreakdown.push(`IGST ${igstTax.tax_percentage}%`);
    }
  } else {
    const nonIgstTaxes = taxOptions.filter((tax) => tax.tax_name !== "IGST");
    nonIgstTaxes.forEach((tax) => {
      if (Number.parseFloat(tax.tax_percentage || 0) > 0) {
        taxBreakdown.push(`${tax.tax_name} ${tax.tax_percentage}%`);
      }
    });
  }

  return taxBreakdown.length > 0
    ? `(${taxBreakdown.join(" + ")})`
    : "Excl. tax";
};

const AddAttendeeModal = ({
  show,
  onHide,
  ticketList,
  buyerForm,
  settingsDetails,
  getAttendeesByEventID,
}) => {
  const [step, setStep] = useState("options");
  const [selectedOption, setSelectedOption] = useState("create");
  const [paymentDate, setPaymentDate] = useState(new Date());
  const [paymentTime, setPaymentTime] = useState(new Date());
  const [selectedTickets, setSelectedTickets] = useState({});
  const [guestCounts, setGuestCounts] = useState({});
  const [attendeesByTicket, setAttendeesByTicket] = useState({});
  const [guestsByTicket, setGuestsByTicket] = useState({});
  const [buyerDetails, setBuyerDetails] = useState({ customFields: {} });
  const [activeTicketId, setActiveTicketId] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [activeAttendee, setActiveAttendee] = useState(0);
  const [activeGuest, setActiveGuest] = useState(0);
  const [showImportModal, setShowImportModal] = useState(false);
  const [isTicketSelected, setIsTicketSelected] = useState(false);
  const [errors, setErrors] = useState({});
  const [isBuyerFormValid, setIsBuyerFormValid] = useState(false);
  const [buyerFormFields, setBuyerFormFields] = useState([]);
  const [showAttendeeImportModal, setShowAttendeeImportModal] = useState(false);

  useEffect(() => {
    if (show) {
      setStep("options");
      setSelectedOption("create");
      setSelectedTickets({});
      setGuestCounts({});
      setAttendeesByTicket({});
      setGuestsByTicket({});
      setBuyerDetails({ customFields: {} });
      setActiveTicketId(null);
      setActiveTab(null);
      setActiveAttendee(0);
      setActiveGuest(0);
      setIsTicketSelected(false);
      setErrors({});
      setIsBuyerFormValid(false);
    }
  }, [show]);

const handleDownloadTemplate = async () => {
  console.log("invoking the function");
  
  const sampleData = [
   
  ['John', 'Doe', 'john.doe@example.com', 'AMASI Member', 'Razorpay'],
  ['Jane', 'Smith', 'jane.smith@example.com', 'Non AMASI Member', 'cheque'],
  ['Robert', 'Johnson', 'robert.j@example.com', 'PGs, NBE, Fellow, M.Ch', 'Offline'],
  ['Sarah', 'Williams', 'sarah.w@example.com', 'FMAS Convocation Delegates', 'Razorpay'],
  ['Michael', 'Brown', 'michael.b@example.com', 'Gynaecologist', 'cheque'],
  ['Emily', 'Davis', 'emily.d@example.com', 'AMASI Member', 'Offline'],
  ['David', 'Miller', 'david.m@example.com', 'Non AMASI Member', 'Razorpay'],
  ['Lisa', 'Wilson', 'lisa.w@example.com', 'PGs, NBE, Fellow, M.Ch', 'cheque'],
  ['James', 'Moore', 'james.m@example.com', 'FMAS Convocation Delegates', 'Offline'],
  ['Patricia', 'Taylor', 'patricia.t@example.com', 'Gynaecologist', 'Razorpay'],
  ['Christopher', 'Anderson', 'chris.anderson@example.com', 'AMASI Member', 'cheque'],
  ['Jennifer', 'Thomas', 'jennifer.thomas@example.com', 'Non AMASI Member', 'Offline'],
  ['Daniel', 'Jackson', 'daniel.jackson@example.com', 'PGs, NBE, Fellow, M.Ch', 'Razorpay'],
  ['Nancy', 'White', 'nancy.white@example.com', 'FMAS Convocation Delegates', 'cheque'],
  ['Matthew', 'Harris', 'matthew.harris@example.com', 'Gynaecologist', 'Offline'],
  ['Karen', 'Martin', 'karen.martin@example.com', 'AMASI Member', 'Razorpay'],
  ['Anthony', 'Thompson', 'anthony.thompson@example.com', 'Non AMASI Member', 'cheque'],
  ['Betty', 'Garcia', 'betty.garcia@example.com', 'PGs, NBE, Fellow, M.Ch', 'Offline'],
  ['Mark', 'Martinez', 'mark.martinez@example.com', 'FMAS Convocation Delegates', 'Razorpay'],
  ['Helen', 'Robinson', 'helen.robinson@example.com', 'Gynaecologist', 'cheque']
  ];

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Attendees');

  // Set column widths
  worksheet.columns = [
    { header: 'first_name', key: 'first_name', width: 15 },
    { header: 'last_name', key: 'last_name', width: 15 },
    { header: 'email', key: 'email', width: 30 },
    { header: 'ticket_name', key: 'ticket_name', width: 30 },
    { header: 'payment_method', key: 'payment_method', width: 38 },
  ];

  // Style header row with rich text (white text + red asterisks)
  const headerRow = worksheet.getRow(1);
  const headerFields = [
    'first_name',
    'last_name',
    'email',
    'ticket_name',
    'payment_method'
  ];
  
  headerFields.forEach((field, index) => {
    const cell = headerRow.getCell(index + 1);
    
    // Use rich text to display field name in white and asterisk in red
    cell.value = {
      richText: [
        { font: { bold: true, color: { argb: 'FFFFFFFF' } }, text: field },
        { font: { bold: true, color: { argb: 'FFFF0000' } }, text: ' *' }
      ]
    };
    
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF184778' }
    };
    
    cell.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
  });

  // Add sample data rows
  sampleData.forEach((row) => {
    worksheet.addRow(row);
  });

  // Add data validation for payment_method column (Column E)
  worksheet.dataValidations.add('E2:E1000', {
    type: 'list',
    allowBlank: false,
    formulae: ['"Razorpay,cheque,Offline"'],
    showDropDown: true,
    prompt: 'Select: Razorpay, cheque, or Offline',
    promptTitle: 'Payment Method',
    error: 'Please select a valid payment method',
    errorTitle: 'Invalid Entry'
  });

  // Generate and download file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'attendees_import_template.xlsx';
  link.click();
  URL.revokeObjectURL(url);
};


const handleImportFile = async (file) => {
  try {
    // Read the file
    const reader = new FileReader();
    
    reader.onload = async (e) => {
      try {
        const data = e.target.result;
        let attendees = [];
        
        // Check file type and parse accordingly
        if (file.name.endsWith('.csv')) {
          // Parse CSV using Papa Parse (you'll need to install: npm install papaparse)
          const Papa = require('papaparse');
          const parsed = Papa.parse(data, { header: true, skipEmptyLines: true });
          attendees = parsed.data;
        } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
          // Parse Excel using SheetJS (you'll need to install: npm install xlsx)
          const XLSX = require('xlsx');
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          attendees = XLSX.utils.sheet_to_json(worksheet);
        }
        
        // Validate imported data
        if (!attendees || attendees.length === 0) {
          showToast("No data found in the file.", "error");
          setShowAttendeeImportModal(false);
          return;
        }
        
        // Validate required columns
        const requiredColumns = ['Ticket Name', 'Email', 'Ticket Price'];
        const firstRow = attendees[0];
        const hasRequiredColumns = requiredColumns.every(col => 
          Object.keys(firstRow).some(key => 
            key.toLowerCase().trim() === col.toLowerCase()
          )
        );
        
        if (!hasRequiredColumns) {
          showToast(
            `Missing required columns. Please ensure your file has: ${requiredColumns.join(', ')}`,
            "error"
          );
          setShowAttendeeImportModal(false);
          return;
        }
        
        // Process the imported attendees
        // Here you can transform the data and create attendees
        console.log('Imported attendees:', attendees);
        
        // Close modal and show success
        setShowAttendeeImportModal(false);
        showToast(`Successfully imported ${attendees.length} attendees!`, "success");
        
        // Move to summary or next step
        setStep("summary");
        
      } catch (parseError) {
        console.error('Parse error:', parseError);
        showToast("Error parsing file. Please check the format.", "error");
        setShowAttendeeImportModal(false);
      }
    };
    
    // Read file based on type
    if (file.name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
    
  } catch (error) {
    console.error('Import error:', error);
    showToast("Error importing file. Please try again.", "error");
    setShowAttendeeImportModal(false);
  }
};

  const shouldShowBuyerForm = () => {
    if (!settingsDetails || settingsDetails.allow_buyers !== 1) {
      return false;
    }
    const totalQuantity = Object.values(selectedTickets).reduce(
      (sum, quantity) => sum + quantity,
      0
    );
    return totalQuantity > 1 && buyerFormFields.length > 0;
  };

  useEffect(() => {
    if (!settingsDetails || !buyerForm || settingsDetails.allow_buyers !== 1) {
      console.log(
        "Buyer form not processed: missing settings or allow_buyers !== 1",
        { settingsDetails, buyerForm }
      );
      setBuyerFormFields([]);
      return;
    }

    const buyerFormId = Number.parseInt(settingsDetails.buyer_form);
    const selectedBuyerForm = buyerForm.find((form) => form.id === buyerFormId);

    if (!selectedBuyerForm) {
      console.error(`No buyer form found with id ${buyerFormId}`, {
        buyerForm,
      });
      setBuyerFormFields([]);
      return;
    }

    // Handle both `fileds` (API typo) and `fields` (potential future correction)
    const formFields = selectedBuyerForm.fileds || selectedBuyerForm.fields;
    if (formFields) {
      try {
        let parsedFields = formFields;
        // Handle potential double-stringified JSON
        while (typeof parsedFields === "string") {
          console.log("Attempting to parse form fields:", {
            formFields: parsedFields,
          });
          parsedFields = JSON.parse(parsedFields);
        }
        if (Array.isArray(parsedFields)) {
          setBuyerFormFields(parsedFields);
          // Initialize buyerDetails with all fields set to empty string
          setBuyerDetails({
            customFields: Object.fromEntries(
              parsedFields.map((field) => [field.id, ""])
            ),
          });
        } else {
          console.error("Parsed buyer form fields is not an array", {
            parsedFields,
          });
          setBuyerFormFields([]);
        }
      } catch (error) {
        console.error("Error parsing buyer form fields:", error, {
          formFields,
        });
        setBuyerFormFields([]);
      }
    } else {
      console.error("No fields or fileds property in selected buyer form", {
        selectedBuyerForm,
      });
      setBuyerFormFields([]);
    }
  }, [settingsDetails, buyerForm]);

  const getInitialCustomFields = (ticketId, isGuest = false) => {
    const ticket = ticketList.find((t) => t.id === Number.parseInt(ticketId));
    const formDetails = parseFormDetails(
      isGuest ? ticket?.guest_details?.form_details : ticket?.form_details
    );
    return Object.fromEntries(formDetails.map((field) => [field.id, ""]));
  };

  useEffect(() => {
    const newAttendeesByTicket = { ...attendeesByTicket };
    Object.keys(selectedTickets).forEach((ticketId) => {
      const totalAttendees = selectedTickets[ticketId] || 0;
      if (!newAttendeesByTicket[ticketId]) {
        newAttendeesByTicket[ticketId] = [];
      }
      if (totalAttendees > newAttendeesByTicket[ticketId].length) {
        const newAttendees = [...newAttendeesByTicket[ticketId]];
        for (let i = newAttendees.length; i < totalAttendees; i++) {
          newAttendees.push({
            customFields: getInitialCustomFields(ticketId),
            addOns: [],
          });
        }
        newAttendeesByTicket[ticketId] = newAttendees;
      } else if (totalAttendees < newAttendeesByTicket[ticketId].length) {
        newAttendeesByTicket[ticketId] = newAttendeesByTicket[ticketId].slice(
          0,
          totalAttendees
        );
      }
    });
    Object.keys(newAttendeesByTicket).forEach((ticketId) => {
      if (!selectedTickets[ticketId]) {
        delete newAttendeesByTicket[ticketId];
      }
    });
    setAttendeesByTicket(newAttendeesByTicket);

    const newGuestsByTicket = { ...guestsByTicket };
    Object.keys(guestCounts).forEach((ticketId) => {
      const totalGuests = guestCounts[ticketId] || 0;
      if (!newGuestsByTicket[ticketId]) {
        newGuestsByTicket[ticketId] = [];
      }
      if (totalGuests > newGuestsByTicket[ticketId].length) {
        const newGuests = [...newGuestsByTicket[ticketId]];
        for (let i = newGuests.length; i < totalGuests; i++) {
          newGuests.push({
            customFields: getInitialCustomFields(ticketId, true),
            assignedAttendee: null,
            addOns: [],
          });
        }
        newGuestsByTicket[ticketId] = newGuests;
      } else if (totalGuests < newGuestsByTicket[ticketId].length) {
        newGuestsByTicket[ticketId] = newGuestsByTicket[ticketId].slice(
          0,
          totalGuests
        );
      }
    });
    Object.keys(newGuestsByTicket).forEach((ticketId) => {
      if (!guestCounts[ticketId]) {
        delete newGuestsByTicket[ticketId];
      }
    });
    setGuestsByTicket(newGuestsByTicket);

    setErrors({});
    if (Object.keys(selectedTickets).length > 0) {
      if (!activeTicketId || !selectedTickets[activeTicketId]) {
        const firstTicketId = Object.keys(selectedTickets)[0];
        setActiveTicketId(firstTicketId);
        const showBuyerTab = shouldShowBuyerForm();
        setActiveTab(showBuyerTab ? "buyer" : firstTicketId);
      }
    } else {
      setActiveTicketId(null);
      setActiveTab(null);
    }
  }, [selectedTickets, guestCounts]);
  const parseFormDetails = (formDetails) => {
    if (typeof formDetails === "string") {
      try {
        const parsed = JSON.parse(formDetails);
        if (Array.isArray(parsed)) {
          return parsed
            .map((field, index) => {
              if (typeof field === "string") {
                return {
                  id: `field-${index}`,
                  type: field === "email" ? "email" : "text",
                  label: field.charAt(0).toUpperCase() + field.slice(1),
                  name: field,
                  placeholder: `Enter ${field}`,
                  required: true,
                  helpText: "",
                };
              } else if (typeof field === "object" && field !== null) {
                return {
                  id: field.id || `field-${index}`,
                  type:
                    field.type || (field.name === "email" ? "email" : "text"),
                  label: field.label || field.name || "Unknown",
                  name:
                    field.name ||
                    field.label?.toLowerCase().replace(/\s+/g, "_") ||
                    "",
                  placeholder:
                    field.placeholder ||
                    `Enter ${field.label || field.name || "value"}`,
                  required:
                    field.required !== undefined ? field.required : true,
                  helpText: field.helpText || "",
                  options: field.options || undefined,
                };
              }
              return null;
            })
            .filter(Boolean);
        }
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error("Error parsing form_details:", error);
        return [];
      }
    } else if (Array.isArray(formDetails)) {
      return formDetails
        .map((field, index) => {
          if (typeof field === "object" && field !== null) {
            return {
              id: field.id || `field-${index}`,
              type: field.type || (field.name === "email" ? "email" : "text"),
              label: field.label || field.name || "Unknown",
              name:
                field.name ||
                field.label?.toLowerCase().replace(/\s+/g, "_") ||
                "",
              placeholder:
                field.placeholder ||
                `Enter ${field.label || field.name || "value"}`,
              required: field.required !== undefined ? field.required : true,
              helpText: field.helpText || "",
              options: field.options || undefined,
            };
          } else if (typeof field === "string") {
            return {
              id: `field-${index}`,
              type: field === "email" ? "email" : "text",
              label: field.charAt(0).toUpperCase() + field.slice(1),
              name: field,
              placeholder: `Enter ${field}`,
              required: true,
              helpText: "",
            };
          }
          return null;
        })
        .filter(Boolean);
    } else if (
      formDetails &&
      formDetails.fields &&
      Array.isArray(formDetails.fields)
    ) {
      return formDetails.fields.map((field, index) => ({
        id: field.id || `field-${index}`,
        type: field.type || (field.name === "email" ? "email" : "text"),
        label: field.label || field.name || "Unknown",
        name:
          field.name || field.label?.toLowerCase().replace(/\s+/g, "_") || "",
        placeholder:
          field.placeholder || `Enter ${field.label || field.name || "value"}`,
        required: field.required !== undefined ? field.required : true,
        helpText: field.helpText || "",
        options: field.options || undefined,
      }));
    }
    return [];
  };
  // const parseFormDetails = (formDetails) => {
  //   if (typeof formDetails === "string") {
  //     const trimmed = formDetails.trim()
  //     if (trimmed === "") {
  //       return []
  //     }
  //     try {
  //       let parsed = JSON.parse(formDetails)
  //       while (typeof parsed === "string") {
  //         parsed = JSON.parse(parsed)
  //       }
  //       if (Array.isArray(parsed)) {
  //         return parsed
  //           .map((field, index) => {
  //             if (typeof field === "string") {
  //               return {
  //                 id: `field-${index}`,
  //                 type: field === "email" ? "email" : "text",
  //                 label: field.charAt(0).toUpperCase() + field.slice(1),
  //                 name: field,
  //                 placeholder: `Enter ${field}`,
  //                 required: true,
  //                 helpText: "",
  //               }
  //             } else if (typeof field === "object" && field !== null) {
  //               return {
  //                 id: field.id || `field-${index}`,
  //                 type: field.type || (field.name === "email" ? "email" : "text"),
  //                 label: field.label || field.name || "Unknown",
  //                 name: field.name || field.label?.toLowerCase().replace(/\s+/g, "_") || "",
  //                 placeholder: field.placeholder || `Enter ${field.label || field.name || "value"}`,
  //                 required: field.required !== undefined ? field.required : true,
  //                 helpText: field.helpText || "",
  //               }
  //             }
  //             return null
  //           })
  //           .filter(Boolean)
  //       }
  //       return Array.isArray(parsed) ? parsed : []
  //     } catch (error) {
  //       console.error("Error parsing form_details:", error)
  //       return []
  //     }
  //   } else if (Array.isArray(formDetails)) {
  //     return formDetails
  //       .map((field, index) => {
  //         if (typeof field === "object" && field !== null) {
  //           return {
  //             id: field.id || `field-${index}`,
  //             type: field.type || (field.name === "email" ? "email" : "text"),
  //             label: field.label || field.name || "Unknown",
  //             name: field.name || field.label?.toLowerCase().replace(/\s+/g, "_") || "",
  //             placeholder: field.placeholder || `Enter ${field.label || field.name || "value"}`,
  //             required: field.required !== undefined ? field.required : true,
  //             helpText: field.helpText || "",
  //           }
  //         } else if (typeof field === "string") {
  //           return {
  //             id: `field-${index}`,
  //             type: field === "email" ? "email" : "text",
  //             label: field.charAt(0).toUpperCase() + field.slice(1),
  //             name: field,
  //             placeholder: `Enter ${field}`,
  //             required: true,
  //             helpText: "",
  //           }
  //         }
  //         return null
  //       })
  //       .filter(Boolean)
  //   } else if (formDetails && formDetails.fields && Array.isArray(formDetails.fields)) {
  //     return formDetails.fields.map((field, index) => ({
  //       id: field.id || `field-${index}`,
  //       type: field.type || (field.name === "email" ? "email" : "text"),
  //       label: field.label || field.name || "Unknown",
  //       name: field.name || field.label?.toLowerCase().replace(/\s+/g, "_") || "",
  //       placeholder: field.placeholder || `Enter ${field.label || field.name || "value"}`,
  //       required: field.required !== undefined ? field.required : true,
  //       helpText: field.helpText || "",
  //     }))
  //   }
  //   return []
  // }

  const validateAttendee = (attendee, index, ticketId, isGuest = false) => {
    const newErrors = {};
    const ticket = ticketList.find((t) => t.id === Number.parseInt(ticketId));
    const formDetails = isGuest
      ? parseFormDetails(ticket?.guest_details?.form_details)
      : parseFormDetails(ticket?.form_details);
    if (!ticket || formDetails.length === 0) {
      return newErrors;
    }

    formDetails.forEach((field) => {
      const value = attendee.customFields?.[field.id];
      const errorKey = `${field.id}_${ticketId}_${index}_${
        isGuest ? "guest" : "attendee"
      }`;

      if (field.required && (!value || value.trim() === "")) {
        newErrors[errorKey] = `${field.label} is required`;
      }

      if (field.type === "email" && value && value.trim() !== "") {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          newErrors[errorKey] = `Invalid email format for ${field.label}`;
        }
      }

      if (
        field.type === "password" &&
        field.required &&
        value &&
        value.trim() !== ""
      ) {
        if (value.length < 8) {
          newErrors[errorKey] = `${field.label} must be at least 8 characters`;
        }
      }

      if (field.type === "number" && value && value.trim() !== "") {
        if (isNaN(Number(value))) {
          newErrors[errorKey] = `Invalid number format for ${field.label}`;
        }
      }
    });

    return newErrors;
  };

  const validateBuyer = (buyer) => {
    const newErrors = {};
    buyerFormFields.forEach((field) => {
      const value = buyer.customFields?.[field.id];
      const errorKey = `${field.id}_buyer`;

      if (field.required && (!value || value.trim() === "")) {
        newErrors[errorKey] = `${field.label} is required`;
      }

      if (field.type === "email" && value && value.trim() !== "") {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          newErrors[errorKey] = `Invalid email format for ${field.label}`;
        }
      }

      if (field.type === "number" && value && value.trim() !== "") {
        if (isNaN(Number(value))) {
          newErrors[errorKey] = `Invalid number format for ${field.label}`;
        }
      }
    });
    return newErrors;
  };

  const checkBuyerFormValidity = (buyer) => {
    const errors = validateBuyer(buyer);
    return Object.keys(errors).length === 0;
  };

  const handleBuyerChange = (fieldId, value) => {
    const safeBuyerDetails = buyerDetails || { customFields: {} };
    const updatedBuyer = {
      ...safeBuyerDetails,
      customFields: {
        ...safeBuyerDetails.customFields,
        [fieldId]: value,
      },
    };
    setBuyerDetails(updatedBuyer);

    const buyerErrors = validateBuyer(updatedBuyer);
    setErrors((prev) => {
      const newErrors = { ...prev };
      Object.keys(prev).forEach((key) => {
        if (key.endsWith("_buyer")) {
          delete newErrors[key];
        }
      });
      return { ...newErrors, ...buyerErrors };
    });
    setIsBuyerFormValid(checkBuyerFormValidity(updatedBuyer));
  };

  const handleAttendeeChange = (ticketId, index, fieldId, value) => {
    const updatedAttendees = { ...attendeesByTicket };
    updatedAttendees[ticketId] = [...updatedAttendees[ticketId]];
    updatedAttendees[ticketId][index] = {
      ...updatedAttendees[ticketId][index],
      customFields: {
        ...updatedAttendees[ticketId][index].customFields,
        [fieldId]: value,
      },
    };
    setAttendeesByTicket(updatedAttendees);

    const attendeeErrors = validateAttendee(
      updatedAttendees[ticketId][index],
      index,
      ticketId
    );
    setErrors((prev) => {
      const newErrors = { ...prev };
      Object.keys(prev).forEach((key) => {
        if (key.endsWith(`_${ticketId}_${index}_attendee`)) {
          delete newErrors[key];
        }
      });
      return { ...newErrors, ...attendeeErrors };
    });
  };

  const handleGuestChange = (ticketId, index, fieldId, value) => {
    const updatedGuests = { ...guestsByTicket };
    updatedGuests[ticketId] = [...updatedGuests[ticketId]];
    updatedGuests[ticketId][index] = {
      ...updatedGuests[ticketId][index],
      customFields: {
        ...updatedGuests[ticketId][index].customFields,
        [fieldId]: value,
      },
    };
    setGuestsByTicket(updatedGuests);

    const guestErrors = validateAttendee(
      updatedGuests[ticketId][index],
      index,
      ticketId,
      true
    );
    setErrors((prev) => {
      const newErrors = { ...prev };
      Object.keys(prev).forEach((key) => {
        if (key.endsWith(`_${ticketId}_${index}_guest`)) {
          delete newErrors[key];
        }
      });
      return { ...newErrors, ...guestErrors };
    });
  };

  const handleGuestAssignChange = (ticketId, index, value) => {
    const updatedGuests = { ...guestsByTicket };
    updatedGuests[ticketId] = [...updatedGuests[ticketId]];
    updatedGuests[ticketId][index].assignedAttendee = value
      ? Number.parseInt(value)
      : null;
    setGuestsByTicket(updatedGuests);
  };

const handleContinue = () => {
  const totalAttendees = Object.values(selectedTickets).reduce(
    (sum, qty) => sum + qty,
    0
  );
  
  if (step === "options") {
    if (selectedOption === "import") {
      // For import, open the import modal directly
      setShowAttendeeImportModal(true);
    } else {
      // For create, proceed to ticket selection
      setStep("tickets");
    }
  } else if (step === "tickets") {
    if (Object.keys(selectedTickets).length === 0) {
      showToast("Please select at least one ticket.", "error");
      return;
    }
    setStep("attendees");
  } else if (step === "attendees") {
    let allErrors = {};
    if (totalAttendees > 1 && shouldShowBuyerForm()) {
      const buyerErrors = validateBuyer(buyerDetails);
      allErrors = { ...allErrors, ...buyerErrors };
      if (Object.keys(buyerErrors).length > 0) {
        showToast(
          "Please complete all required buyer details before proceeding.",
          "error"
        );
      }
    }
    Object.keys(attendeesByTicket).forEach((ticketId) => {
      attendeesByTicket[ticketId].forEach((attendee, index) => {
        const attendeeErrors = validateAttendee(attendee, index, ticketId);
        allErrors = { ...allErrors, ...attendeeErrors };
      });
    });
    Object.keys(guestsByTicket).forEach((ticketId) => {
      guestsByTicket[ticketId].forEach((guest, index) => {
        const guestErrors = validateAttendee(guest, index, ticketId, true);
        allErrors = { ...allErrors, ...guestErrors };
      });
    });
    setErrors(allErrors);
    if (Object.keys(allErrors).length === 0) {
      setStep("summary");
    } else {
      showToast(
        "Please fill all required fields for attendees and guests.",
        "error"
      );
    }
  } else if (step === "summary") {
    handleSubmit();
  }
};


  const handleBack = () => {
    if (step === "tickets") {
      setStep("options");
    } else if (step === "attendees") {
      setStep("tickets");
    } else if (step === "summary") {
      setStep("attendees");
    }
  };

  const handleAddTicket = (ticketId) => {
    const ticket = ticketList.find((t) => t.id === ticketId);
    if (ticket.quantity > 0) {
      setSelectedTickets((prev) => {
        const newSelectedTickets = { ...prev, [ticketId]: 1 };
        setIsTicketSelected(true);
        return newSelectedTickets;
      });
      setAttendeesByTicket((prev) => ({
        ...prev,
        [ticketId]: [
          { customFields: getInitialCustomFields(ticketId), addOns: [] },
        ],
      }));
    } else {
      showToast("No tickets available for selection.", "error");
    }
  };

  const handleIncreaseQuantity = (ticketId) => {
    const ticket = ticketList.find((t) => t.id === ticketId);
    setSelectedTickets((prev) => {
      const currentQuantity = prev[ticketId] || 0;
      if (currentQuantity < ticket.quantity) {
        return { ...prev, [ticketId]: currentQuantity + 1 };
      } else {
        showToast(
          `Cannot add more tickets. Maximum limit is ${ticket.quantity}.`,
          "error"
        );
        return prev;
      }
    });
  };

  const handleDecreaseQuantity = (ticketId) => {
    setSelectedTickets((prev) => {
      const currentQuantity = prev[ticketId] || 0;
      if (currentQuantity > 0) {
        const newQuantity = currentQuantity - 1;
        const newSelectedTickets = { ...prev };
        if (newQuantity === 0) {
          delete newSelectedTickets[ticketId];
          setIsTicketSelected(Object.keys(newSelectedTickets).length > 0);
          if (activeTicketId === ticketId) {
            const remainingTicketIds = Object.keys(newSelectedTickets);
            setActiveTicketId(remainingTicketIds[0] || null);
            setActiveTab(
              remainingTicketIds.length > 1
                ? "buyer"
                : remainingTicketIds[0] || null
            );
          }
          setGuestCounts((prevCounts) => {
            const newGuestCounts = { ...prevCounts };
            delete newGuestCounts[ticketId];
            return newGuestCounts;
          });
          setGuestsByTicket((prevGuests) => {
            const newGuestsByTicket = { ...prevGuests };
            delete newGuestsByTicket[ticketId];
            return newGuestsByTicket;
          });
        } else {
          newSelectedTickets[ticketId] = newQuantity;
        }
        return newSelectedTickets;
      }
      return prev;
    });
  };

  const handleAddGuests = (ticketId) => {
    const ticket = ticketList.find((t) => t.id === Number.parseInt(ticketId));
    if (!ticket || !ticket.guest_details) {
      showToast("This ticket does not support guests.", "error");
      return;
    }
    const maxGuests = ticket.guest_details.quantity || 0;
    setGuestCounts((prev) => {
      const currentGuests = prev[ticketId] || 0;
      if (currentGuests < maxGuests) {
        return { ...prev, [ticketId]: currentGuests + 1 };
      } else {
        showToast(
          `Cannot add more guests. Maximum limit is ${maxGuests}.`,
          "error"
        );
        return prev;
      }
    });
  };

  const handleAddOnQuantityChange = (
    ticketId,
    attendeeIndex,
    addonId,
    variantName = null,
    delta
  ) => {
    const ticket = ticketList.find((t) => t.id === Number.parseInt(ticketId));
    const addon = ticket.addons.find((a) => a.id === addonId);
    let maxQuantity = addon.quantity || 1;
    if (variantName && addon.variant_options) {
      const variantOption = addon.variant_options.find(
        (v) => v.variant_name === variantName
      );
      if (variantOption) {
        maxQuantity = variantOption.quantity_available || 1;
      }
    }

    const updatedAttendees = { ...attendeesByTicket };
    const currentAddOns =
      updatedAttendees[ticketId][attendeeIndex].addOns || [];
    const addOnIndex = currentAddOns.findIndex(
      (addOn) =>
        addOn.id === addonId &&
        (variantName ? addOn.variant === variantName : !addOn.variant)
    );

    if (addOnIndex === -1) {
      if (delta > 0 && maxQuantity > 0) {
        updatedAttendees[ticketId][attendeeIndex].addOns = [
          ...currentAddOns,
          { id: addonId, variant: variantName, quantity: 1 },
        ];
      }
    } else {
      const newQuantity = currentAddOns[addOnIndex].quantity + delta;
      if (newQuantity <= 0) {
        updatedAttendees[ticketId][attendeeIndex].addOns = currentAddOns.filter(
          (addOn) =>
            !(
              addOn.id === addonId &&
              (variantName ? addOn.variant === variantName : !addOn.variant)
            )
        );
      } else if (newQuantity <= maxQuantity) {
        updatedAttendees[ticketId][attendeeIndex].addOns = [
          ...currentAddOns.slice(0, addOnIndex),
          { ...currentAddOns[addOnIndex], quantity: newQuantity },
          ...currentAddOns.slice(addOnIndex + 1),
        ];
      } else {
        showToast(
          `Cannot exceed available quantity (${maxQuantity}) for ${
            variantName || addon.add_on_name
          }.`,
          "error"
        );
      }
    }
    setAttendeesByTicket(updatedAttendees);
  };

  const handleGuestAddOnQuantityChange = (
    ticketId,
    guestIndex,
    addonId,
    variantName = null,
    delta
  ) => {
    const ticket = ticketList.find((t) => t.id === Number.parseInt(ticketId));
    const addon = ticket.guest_details?.addons.find((a) => a.id === addonId);
    let maxQuantity = addon.quantity || 1;
    if (variantName && addon.variant_options) {
      const variantOption = addon.variant_options.find(
        (v) => v.variant_name === variantName
      );
      if (variantOption) {
        maxQuantity = variantOption.quantity_available || 1;
      }
    }

    const updatedGuests = { ...guestsByTicket };
    const currentAddOns = updatedGuests[ticketId][guestIndex].addOns || [];
    const addOnIndex = currentAddOns.findIndex(
      (addOn) =>
        addOn.id === addonId &&
        (variantName ? addOn.variant === variantName : !addOn.variant)
    );

    if (addOnIndex === -1) {
      if (delta > 0 && maxQuantity > 0) {
        updatedGuests[ticketId][guestIndex].addOns = [
          ...currentAddOns,
          { id: addonId, variant: variantName, quantity: 1 },
        ];
      }
    } else {
      const newQuantity = currentAddOns[addOnIndex].quantity + delta;
      if (newQuantity <= 0) {
        updatedGuests[ticketId][guestIndex].addOns = currentAddOns.filter(
          (addOn) =>
            !(
              addOn.id === addonId &&
              (variantName ? addOn.variant === variantName : !addOn.variant)
            )
        );
      } else if (newQuantity <= maxQuantity) {
        updatedGuests[ticketId][guestIndex].addOns = [
          ...currentAddOns.slice(0, addOnIndex),
          { ...currentAddOns[addOnIndex], quantity: newQuantity },
          ...currentAddOns.slice(addOnIndex + 1),
        ];
      } else {
        showToast(
          `Cannot exceed available quantity (${maxQuantity}) for ${
            variantName || addon.add_on_name
          }.`,
          "error"
        );
      }
    }
    setGuestsByTicket(updatedGuests);
  };

  const handleImportComplete = (importedData) => {
  console.log("Import completed successfully:", importedData);
  
  // Close the import modal
  setShowAttendeeImportModal(false);
  
  // Refresh the attendees list
  getAttendeesByEventID();
  
  // Show success message
  showToast(`Successfully imported ${importedData.length} attendees!`, "success");
  
  // Close the main modal
  onHide();
};


  const [addAttendeeStatus, setAddAttendeeStatus] = useState(false);
  const handleSubmit = async () => {
    setAddAttendeeStatus(true);
    const totalAttendees = Object.values(selectedTickets).reduce(
      (sum, qty) => sum + qty,
      0
    );
    try {
      const formattedDate = paymentDate.toISOString().split("T")[0];
      const formattedTime = paymentTime.toTimeString().split(" ")[0];
      const paymentDateTime = `${formattedDate} ${formattedTime}`;

      let total_amount = 0;
      let total_ticket_amount = 0;
      let total_addons_amount = 0;
      let total_tax_amount = 0;

      const payload = {
        event_id: Number.parseInt(localStorage.getItem("eventId")),
        tickets: Object.keys(selectedTickets).map((ticketId) => {
          const ticket = ticketList.find(
            (t) => t.id === Number.parseInt(ticketId)
          );
          const formDetails = parseFormDetails(ticket?.form_details);
          const guestFormDetails = ticket?.guest_details
            ? parseFormDetails(ticket.guest_details.form_details)
            : [];
          const attendees = attendeesByTicket[ticketId] || [];
          const guests = guestsByTicket[ticketId] || [];
          console.log(attendees, "attendees:");
          // Ticket price calculation
          let ticketPrice = Number.parseFloat(ticket?.price || 0);
          if (ticket?.variable_prices) {
            const now = new Date();
            const validPrice = ticket.variable_prices
              .filter((vp) => new Date(vp.valid_till) >= now)
              .sort(
                (a, b) => new Date(b.valid_till) - new Date(a.valid_till)
              )[0];
            ticketPrice = validPrice
              ? Number.parseFloat(validPrice.price)
              : ticketPrice;
          }

          let ticketTaxPercentage = 0;
          let ticketTaxName = "No Tax";
          let ticketTaxAmount = 0;
          if (
            ticket?.tax_type === "Excluding Tax" &&
            ticket?.tax_options?.length > 0
          ) {
            if (settingsDetails?.state_is_same === "no") {
              // Use IGST for inter-state transactions
              const igstTax = ticket.tax_options.find(
                (tax) => tax.tax_name === "IGST"
              );
              if (igstTax) {
                ticketTaxPercentage = Number.parseFloat(
                  igstTax.tax_percentage || 0
                );
                ticketTaxName = "IGST";
              }
            } else {
              // Use non-IGST taxes for intra-state transactions
              const nonIgstTaxes = ticket.tax_options.filter(
                (tax) => tax.tax_name !== "IGST"
              );
              ticketTaxPercentage = nonIgstTaxes.reduce(
                (sum, tax) => sum + Number.parseFloat(tax.tax_percentage || 0),
                0
              );
              ticketTaxName = nonIgstTaxes
                .map((tax) => tax.tax_name)
                .join(", ");
            }
            console.log(
              "[v0] Ticket tax calculation - Price:",
              ticketPrice,
              "Tax%:",
              ticketTaxPercentage
            );
            ticketTaxAmount = (ticketPrice * ticketTaxPercentage) / 100;
            console.log("[v0] Calculated tax amount:", ticketTaxAmount);
          } else {
            // For Including Tax and No Tax, no tax calculation
            ticketTaxAmount = 0;
            ticketTaxPercentage = 0;
            ticketTaxName = "No Tax";
          }

          let guestTicketPrice = ticket?.guest_details
            ? Number.parseFloat(ticket.guest_details.price || 0)
            : 0;
          if (ticket?.guest_details?.variable_prices) {
            const now = new Date();
            const validGuestPrice = ticket.guest_details.variable_prices
              .filter((vp) => new Date(vp.valid_till) >= now)
              .sort(
                (a, b) => new Date(b.valid_till) - new Date(a.valid_till)
              )[0];
            guestTicketPrice = validGuestPrice
              ? Number.parseFloat(validGuestPrice.price)
              : guestTicketPrice;
          }

          let guestTaxPercentage = 0;
          let guestTaxName = "No Tax";
          let guestTicketTaxAmount = 0;
          if (
            ticket?.guest_details?.tax_type === "Excluding Tax" &&
            ticket?.guest_details?.tax_options?.length > 0
          ) {
            if (settingsDetails?.state_is_same === "no") {
              const igstTax = ticket.guest_details.tax_options.find(
                (tax) => tax.tax_name === "IGST"
              );
              if (igstTax) {
                guestTaxPercentage = Number.parseFloat(
                  igstTax.tax_percentage || 0
                );
                guestTaxName = "IGST";
              }
            } else {
              const nonIgstTaxes = ticket.guest_details.tax_options.filter(
                (tax) => tax.tax_name !== "IGST"
              );
              guestTaxPercentage = nonIgstTaxes.reduce(
                (sum, tax) => sum + Number.parseFloat(tax.tax_percentage || 0),
                0
              );
              guestTaxName = nonIgstTaxes.map((tax) => tax.tax_name).join(", ");
            }
            guestTicketTaxAmount =
              (guestTicketPrice * guestTaxPercentage * guests.length) / 100;
          } else {
            // For Including Tax and No Tax on guests, no tax
            guestTicketTaxAmount = 0;
            guestTaxPercentage = 0;
            guestTaxName = "No Tax";
          }
          const guestTicketAmount = guests.length * guestTicketPrice; // Fixed guest ticket amount calculation to use base price without tax deduction

          const attendeeFormData = [
            {
              custom_fields: formDetails.map((field) => {
                const value = attendees[0].customFields?.[field.id] || "";
                return {
                  id: field.id,
                  type: field.type || "text",
                  label: field.label || "Unknown",
                  name:
                    field.name ||
                    field.label?.toLowerCase().replace(/\s+/g, "_") ||
                    "",
                  value:
                    field.type === "number"
                      ? value
                        ? Number(value)
                        : null
                      : value,
                };
              }),
              add_ons: attendees[0].addOns.map((addOn) => ({
                addon_id: addOn.id,
                variant_name: addOn.variant || null,
                quantity: addOn.quantity,
              })),
            },
          ];

          const guestData = guests.map((guest) => ({
            ticket_id: Number.parseInt(ticketId),
            custom_fields: Object.entries(guest.customFields || {}).map(
              ([id, value]) => {
                const field = guestFormDetails.find((f) => f.id === id);
                return {
                  id,
                  type: field?.type || "text",
                  label: field?.label || "Unknown",
                  name:
                    field?.name ||
                    field?.label?.toLowerCase().replace(/\s+/g, "_") ||
                    "",
                  value:
                    field?.type === "number"
                      ? value
                        ? Number(value)
                        : null
                      : value,
                };
              }
            ),

            add_ons: guest.addOns
              ? guest.addOns.map((addOn) => ({
                  addon_id: addOn.id,
                  variant_name: addOn.variant || null,
                  quantity: addOn.quantity,
                }))
              : [],
          }));

          const firstNameField = formDetails.find(
            (f) => f.name === "first_name"
          );
          const lastNameField = formDetails.find((f) => f.name === "last_name");
          const emailField = formDetails.find(
            (f) => f.name === "email_address"
          );
          const firstName = firstNameField
            ? attendees[0].customFields[firstNameField.id]
            : "";
          const lastName = lastNameField
            ? attendees[0].customFields[lastNameField.id]
            : "";
          const emailAddress = emailField
            ? attendees[0].customFields[emailField.id]
            : "";

          const attendeeTicketAmount = attendees.length * ticketPrice; // Use base ticket price directly
          let attendeeAddOnAmount = 0;
          let addonTaxAmount = 0;

          // Consolidate add-ons by ID
          const addOnsById = {};
          attendees[0].addOns.forEach((addOn) => {
            if (!addOnsById[addOn.id]) {
              addOnsById[addOn.id] = {
                id: addOn.id,
                variants: [],
                totalQuantity: 0,
              };
            }
            if (addOn.variant) {
              addOnsById[addOn.id].variants.push({
                variant_name: addOn.variant,
                quantity: addOn.quantity,
              });
            }
            addOnsById[addOn.id].totalQuantity += addOn.quantity;
          });

          const addOnsData = Object.values(addOnsById)
            .map((addOnEntry) => {
              const matchingAddOn = ticket.addons.find(
                (a) => a.id === addOnEntry.id
              );
              if (matchingAddOn) {
                let totalAddonPrice = 0;
                if (
                  matchingAddOn.variant_options &&
                  matchingAddOn.variant_options.length > 0
                ) {
                  addOnEntry.variants.forEach((variant) => {
                    const variantOption = matchingAddOn.variant_options.find(
                      (v) => v["variant_name"] === variant.variant_name
                    );
                    if (variantOption) {
                      totalAddonPrice +=
                        Number.parseFloat(variantOption["variant_price"] || 0) *
                        variant.quantity;
                    }
                  });
                } else {
                  const addonPrice = Number.parseFloat(
                    matchingAddOn.price || 0
                  );
                  totalAddonPrice = addonPrice * addOnEntry.totalQuantity;
                }

                let addonTaxPercentage = 0;
                if (
                  matchingAddOn.tax_type === "Excluding Tax" &&
                  matchingAddOn.tax_options?.length > 0
                ) {
                  if (settingsDetails?.state_is_same === "no") {
                    const igstTax = matchingAddOn.tax_options.find(
                      (tax) => tax.tax_name === "IGST"
                    );
                    if (igstTax) {
                      addonTaxPercentage = Number.parseFloat(
                        igstTax.tax_percentage || 0
                      );
                    }
                  } else {
                    const nonIgstTaxes = matchingAddOn.tax_options.filter(
                      (tax) => tax.tax_name !== "IGST"
                    );
                    addonTaxPercentage = nonIgstTaxes.reduce(
                      (sum, tax) =>
                        sum + Number.parseFloat(tax.tax_percentage || 0),
                      0
                    );
                  }
                } else {
                  // No tax for Excluding Tax and No Tax on addons
                  addonTaxPercentage = 0;
                }

                const addonBasePrice = totalAddonPrice;
                let addonTaxForThis = 0;
                if (
                  matchingAddOn.tax_type === "Excluding Tax" &&
                  addonTaxPercentage > 0
                ) {
                  console.log(
                    "[v0] Addon tax calculation - Price:",
                    totalAddonPrice,
                    "Tax%:",
                    addonTaxPercentage
                  );
                  addonTaxForThis =
                    (totalAddonPrice * addonTaxPercentage) / 100;
                  console.log("[v0] Addon tax amount:", addonTaxForThis);
                } else if (
                  matchingAddOn.tax_type === "Including Tax" &&
                  addonTaxPercentage > 0
                ) {
                  // For including tax, extract the base price
                  const basePrice =
                    totalAddonPrice / (1 + addonTaxPercentage / 100);
                  addonTaxForThis = totalAddonPrice - basePrice;
                  attendeeAddOnAmount += basePrice;
                } else {
                  addonTaxForThis = 0;
                  attendeeAddOnAmount += addonBasePrice;
                }

                if (matchingAddOn.tax_type !== "Including Tax") {
                  attendeeAddOnAmount += addonBasePrice;
                }
                addonTaxAmount += addonTaxForThis;

                return {
                  id: matchingAddOn.id,
                  user_id: matchingAddOn.user_id,
                  event_id: matchingAddOn.event_id,
                  isMandatory: matchingAddOn.isMandatory,
                  addons_type: matchingAddOn.addons_type,
                  add_on_name: matchingAddOn.add_on_name,
                  description: matchingAddOn.description,
                  price_type: matchingAddOn.price_type,
                  price: matchingAddOn.price,
                  currency: matchingAddOn.currency,
                  tax_type: matchingAddOn.tax_type,
                  tax_options: matchingAddOn.tax_options,
                  variant_options: matchingAddOn.variant_options,
                  selected_variant: null,
                  quantity: addOnEntry.totalQuantity,
                  addon_status: matchingAddOn.addon_status,
                  created_at: matchingAddOn.created_at,
                  maxQuantity:
                    matchingAddOn.maxQuantity || matchingAddOn.quantity,
                  variant: null,
                  registered_variants: addOnEntry.variants,
                };
              }
              return null;
            })
            .filter(Boolean);

          let guestAddOnAmount = 0;
          let guestAddonTaxAmount = 0;
          guests.forEach((guest) => {
            (guest.addOns || []).forEach((addOn) => {
              const matchingAddOn = ticket.guest_details?.addons.find(
                (a) => a.id === addOn.id
              );
              if (matchingAddOn) {
                let addonPrice = Number.parseFloat(matchingAddOn.price || 0);
                if (
                  matchingAddOn.variant_options &&
                  matchingAddOn.variant_options.length > 0
                ) {
                  const variant = matchingAddOn.variant_options.find(
                    (v) => v["variant_name"] === addOn.variant
                  );
                  addonPrice = variant
                    ? Number.parseFloat(variant["variant_price"] || "0")
                    : addonPrice;
                }

                let addonTaxPercentage = 0;
                if (
                  matchingAddOn.tax_type === "Excluding Tax" &&
                  matchingAddOn.tax_options?.length > 0
                ) {
                  if (settingsDetails?.state_is_same === "no") {
                    const igstTax = matchingAddOn.tax_options.find(
                      (tax) => tax.tax_name === "IGST"
                    );
                    if (igstTax) {
                      addonTaxPercentage = Number.parseFloat(
                        igstTax.tax_percentage || 0
                      );
                    }
                  } else {
                    const nonIgstTaxes = matchingAddOn.tax_options.filter(
                      (tax) => tax.tax_name !== "IGST"
                    );
                    addonTaxPercentage = nonIgstTaxes.reduce(
                      (sum, tax) =>
                        sum + Number.parseFloat(tax.tax_percentage || 0),
                      0
                    );
                  }
                } else {
                  addonTaxPercentage = 0;
                }

                const addonBasePrice = addonPrice;
                let addonTaxForThis = 0;
                if (
                  matchingAddOn.tax_type === "Excluding Tax" &&
                  addonTaxPercentage > 0
                ) {
                  console.log(
                    "[v0] Guest addon tax calculation - Price:",
                    addonPrice,
                    "Tax%:",
                    addonTaxPercentage,
                    "Qty:",
                    addOn.quantity
                  );
                  addonTaxForThis =
                    (addonPrice * addonTaxPercentage * addOn.quantity) / 100;
                  console.log("[v0] Guest addon tax amount:", addonTaxForThis);
                  guestAddOnAmount += addonBasePrice * addOn.quantity;
                } else if (
                  matchingAddOn.tax_type === "Including Tax" &&
                  addonTaxPercentage > 0
                ) {
                  // For including tax, extract the base price
                  const basePrice = addonPrice / (1 + addonTaxPercentage / 100);
                  addonTaxForThis = (addonPrice - basePrice) * addOn.quantity;
                  guestAddOnAmount += basePrice * addOn.quantity;
                } else {
                  addonTaxForThis = 0;
                  guestAddOnAmount += addonBasePrice * addOn.quantity;
                }

                guestAddonTaxAmount += addonTaxForThis;
              }
            });
          });

          const ticketBaseAmount = attendeeTicketAmount + guestTicketAmount;
          const totalTicketTax = ticketTaxAmount + guestTicketTaxAmount;
          const totalAddonAmount = attendeeAddOnAmount + guestAddOnAmount;
          const totalAddonTax = addonTaxAmount + guestAddonTaxAmount;
          const totalTaxAmount = totalTicketTax + totalAddonTax;
          const actualPaymentAmount =
            ticketBaseAmount + totalAddonAmount + totalTaxAmount;

          total_ticket_amount += ticketBaseAmount;
          total_addons_amount += totalAddonAmount;
          total_tax_amount += totalTaxAmount;
          total_amount += actualPaymentAmount;

          const attendeeData = attendees.map((attendee) => ({
            form_id: ticket?.form_id || 1,
            form_data: [
              {
                custom_fields: Object.entries(attendee.customFields || {}).map(
                  ([id, value]) => {
                    const field = formDetails.find((f) => f.id === id);
                    return {
                      id,
                      type: field?.type || "text",
                      label: field?.label || "Unknown",
                      name:
                        field?.name ||
                        field?.label?.toLowerCase().replace(/\s+/g, "_") ||
                        "",
                      value:
                        field?.type === "number"
                          ? value
                            ? Number(value)
                            : null
                          : value,
                    };
                  }
                ),
                add_ons: attendee.addOns.map((addOn) => ({
                  addon_id: addOn.id,
                  variant_name: addOn.variant || null,
                  quantity: addOn.quantity,
                })),
              },
            ],
            ticket_data: ticket,
            guest_data: guestData,
            first_name: firstName,
            last_name: lastName,
            email: emailAddress,
            add_ons_data: addOnsData,
            actual_payment_amount: actualPaymentAmount.toFixed(2),
            add_on_amount: totalAddonAmount.toFixed(2),
            ticket_amount: ticketBaseAmount.toFixed(2),
            ticket_taxname: ticketTaxName,
            ticket_taxpercentage: ticketTaxPercentage,
            ticket_amount_with_tax: (ticketBaseAmount + totalTicketTax).toFixed(
              2
            ),
          }));

          return {
            ticket_id: Number.parseInt(ticketId),
            attendee_data: attendeeData,
          };
        }),

        ...(shouldShowBuyerForm() && {
          buyer_details: {
            buyer_type: "individual",
            custom_fields: buyerFormFields.map((field) => {
              const value = buyerDetails.customFields?.[field.id] || "";
              return {
                id: field.id,
                type: field.type || "text",
                label: field.label || "Unknown",
                name:
                  field.name ||
                  field.label?.toLowerCase().replace(/\s+/g, "_") ||
                  "",
                value:
                  field.type === "number"
                    ? value
                      ? Number(value)
                      : null
                    : value,
              };
            }),
          },
        }),
        ticket_count: Object.values(selectedTickets).reduce(
          (sum, qty) => sum + qty,
          0
        ),
        payment_date: paymentDateTime,
        payment_method: "Cheque",
        payment_received: total_amount.toFixed(2),
        additional_notes: "",
        total_addons_amount: total_addons_amount.toFixed(2),
        total_tax_amount: total_tax_amount.toFixed(2),
        total_ticket_amount: total_ticket_amount.toFixed(2),
        total_amount: total_amount.toFixed(2),
        currency: ticketList[0]?.currency || "",
        order_status: "confirmed",
      };
      console.log("Payload to submit:", payload);
      const response = await axios.post(
        `${localserver}/create_attendees`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.success) {
        showToast(response.data.message, "success");
        getAttendeesByEventID();
        onHide();
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error submitting attendees:", error);
      showToast("Failed to submit attendees. Please try again.", "error");
    } finally {
      setAddAttendeeStatus(false);
    }
  };

  if (!show) return null;

  const totalAttendees = Object.values(selectedTickets).reduce(
    (sum, qty) => sum + qty,
    0
  );

  // Function to get paid price for display
  const getPaidPrice = (price, taxType, taxPercentage) => {
    if (taxType === "Excluding Tax" && taxPercentage > 0) {
      console.log(
        "[v0] getPaidPrice - Base price:",
        price,
        "Tax%:",
        taxPercentage
      );
      const totalPrice = price + (price * taxPercentage) / 100;
      console.log("[v0] Total price with tax:", totalPrice);
      return totalPrice;
    } else if (taxType === "Including Tax" && taxPercentage > 0) {
      return price;
    }
    return price;
  };

  // Function to calculate summary items
  const calculateSummary = () => {
    const summaryItems = [];
    let totalPaid = 0;

    // Tickets
    Object.keys(selectedTickets).forEach((ticketId) => {
      const ticket = ticketList.find((t) => t.id === Number.parseInt(ticketId));
      let ticketPrice = Number.parseFloat(ticket.price || 0);
      if (ticket.variable_prices) {
        const now = new Date();
        const validPrice = ticket.variable_prices
          .filter((vp) => new Date(vp.valid_till) >= now)
          .sort((a, b) => new Date(b.valid_till) - new Date(a.valid_till))[0];
        ticketPrice = validPrice
          ? Number.parseFloat(validPrice.price)
          : ticketPrice;
      }
      let taxPercentage = 0;
      if (ticket.tax_type === "Excluding Tax" && ticket.tax_options) {
        if (settingsDetails?.state_is_same === "no") {
          const igstTax = ticket.tax_options.find(
            (tax) => tax.tax_name === "IGST"
          );
          if (igstTax) {
            taxPercentage = Number.parseFloat(igstTax.tax_percentage || 0);
          }
        } else {
          const nonIgstTaxes = ticket.tax_options.filter(
            (tax) => tax.tax_name !== "IGST"
          );
          taxPercentage = nonIgstTaxes.reduce(
            (sum, tax) => sum + Number.parseFloat(tax.tax_percentage || 0),
            0
          );
        }
      } else {
        taxPercentage = 0; // No tax for Excluding Tax and No Tax
      }
      const paidPrice = getPaidPrice(
        ticketPrice,
        ticket.tax_type,
        taxPercentage
      );
      const quantity = selectedTickets[ticketId];
      const subtotal = paidPrice * quantity;
      summaryItems.push({
        name: ticket.ticket_name,
        price: paidPrice,
        quantity,
        subtotal,
      });
      totalPaid += subtotal;
    });

    // Add-ons for attendees
    Object.keys(attendeesByTicket).forEach((ticketId) => {
      attendeesByTicket[ticketId].forEach((attendee) => {
        attendee.addOns.forEach((addOn) => {
          const ticket = ticketList.find(
            (t) => t.id === Number.parseInt(ticketId)
          );
          const matchingAddOn = ticket.addons.find((a) => a.id === addOn.id);
          if (matchingAddOn) {
            let price = Number.parseFloat(matchingAddOn.price || 0);
            let name = matchingAddOn.add_on_name;
            if (matchingAddOn.variant_options && addOn.variant) {
              const variant = matchingAddOn.variant_options.find(
                (v) => v.variant_name === addOn.variant
              );
              if (variant) {
                price = Number.parseFloat(variant.variant_price || 0);
                name += ` (${addOn.variant})`;
              }
            }
            let taxPercentage = 0;
            if (
              matchingAddOn.tax_type === "Excluding Tax" &&
              matchingAddOn.tax_options
            ) {
              if (settingsDetails?.state_is_same === "no") {
                const igstTax = matchingAddOn.tax_options.find(
                  (tax) => tax.tax_name === "IGST"
                );
                if (igstTax) {
                  taxPercentage = Number.parseFloat(
                    igstTax.tax_percentage || 0
                  );
                }
              } else {
                const nonIgstTaxes = matchingAddOn.tax_options.filter(
                  (tax) => tax.tax_name !== "IGST"
                );
                taxPercentage = nonIgstTaxes.reduce(
                  (sum, tax) =>
                    sum + Number.parseFloat(tax.tax_percentage || 0),
                  0
                );
              }
            } else {
              taxPercentage = 0; // No tax for Excluding Tax and No Tax on addons
            }
            const paidPrice = getPaidPrice(
              price,
              matchingAddOn.tax_type,
              taxPercentage
            );
            const subtotal = paidPrice * addOn.quantity;
            summaryItems.push({
              name: `Add-on: ${name}`,
              price: paidPrice,
              quantity: addOn.quantity,
              subtotal,
            });
            totalPaid += subtotal;
          }
        });
      });
    });

    // Guest add-ons
    Object.keys(guestCounts).forEach((ticketId) => {
      const guests = guestsByTicket[ticketId] || [];
      guests.forEach((guest) => {
        guest.addOns.forEach((addOn) => {
          const ticket = ticketList.find(
            (t) => t.id === Number.parseInt(ticketId)
          );
          const matchingAddOn = ticket.guest_details?.addons.find(
            (a) => a.id === addOn.id
          );
          if (matchingAddOn) {
            let price = Number.parseFloat(matchingAddOn.price || 0);
            let name = matchingAddOn.add_on_name;
            if (matchingAddOn.variant_options && addOn.variant) {
              const variant = matchingAddOn.variant_options.find(
                (v) => v.variant_name === addOn.variant
              );
              if (variant) {
                price = Number.parseFloat(variant.variant_price || 0);
                name += ` (${addOn.variant})`;
              }
            }
            let taxPercentage = 0;
            if (
              matchingAddOn.tax_type === "Excluding Tax" &&
              matchingAddOn.tax_options
            ) {
              if (settingsDetails?.state_is_same === "no") {
                const igstTax = matchingAddOn.tax_options.find(
                  (tax) => tax.tax_name === "IGST"
                );
                if (igstTax) {
                  taxPercentage = Number.parseFloat(
                    igstTax.tax_percentage || 0
                  );
                }
              } else {
                const nonIgstTaxes = matchingAddOn.tax_options.filter(
                  (tax) => tax.tax_name !== "IGST"
                );
                taxPercentage = nonIgstTaxes.reduce(
                  (sum, tax) =>
                    sum + Number.parseFloat(tax.tax_percentage || 0),
                  0
                );
              }
            } else {
              taxPercentage = 0;
            }
            const paidPrice = getPaidPrice(
              price,
              matchingAddOn.tax_type,
              taxPercentage
            );
            const subtotal = paidPrice * addOn.quantity;
            summaryItems.push({
              name: `Guest Add-on: ${name}`,
              price: paidPrice,
              quantity: addOn.quantity,
              subtotal,
            });
            totalPaid += subtotal;
          }
        });
      });
    });

    // Guest tickets (if priced)
    Object.keys(guestCounts).forEach((ticketId) => {
      const ticket = ticketList.find((t) => t.id === Number.parseInt(ticketId));
      if (ticket && ticket.guest_details && guestCounts[ticketId] > 0) {
        let guestPrice = Number.parseFloat(ticket.guest_details.price || 0);
        if (ticket.guest_details.variable_prices) {
          const now = new Date();
          const validGuestPrice = ticket.guest_details.variable_prices
            .filter((vp) => new Date(vp.valid_till) >= now)
            .sort((a, b) => new Date(b.valid_till) - new Date(a.valid_till))[0];
          guestPrice = validGuestPrice
            ? Number.parseFloat(validGuestPrice.price)
            : guestPrice;
        }
        let guestTaxPercentage = 0;
        if (
          ticket.guest_details.tax_type === "Excluding Tax" &&
          ticket.guest_details.tax_options
        ) {
          if (settingsDetails?.state_is_same === "no") {
            const igstTax = ticket.guest_details.tax_options.find(
              (tax) => tax.tax_name === "IGST"
            );
            if (igstTax) {
              guestTaxPercentage = Number.parseFloat(
                igstTax.tax_percentage || 0
              );
            }
          } else {
            const nonIgstTaxes = ticket.guest_details.tax_options.filter(
              (tax) => tax.tax_name !== "IGST"
            );
            guestTaxPercentage = nonIgstTaxes.reduce(
              (sum, tax) => sum + Number.parseFloat(tax.tax_percentage || 0),
              0
            );
          }
        } else {
          guestTaxPercentage = 0;
        }
        const paidPrice = getPaidPrice(
          guestPrice,
          ticket.guest_details.tax_type,
          guestTaxPercentage
        );
        const quantity = guestCounts[ticketId];
        const subtotal = paidPrice * quantity;
        summaryItems.push({
          name: `Guest for ${ticket.ticket_name}`,
          price: paidPrice,
          quantity,
          subtotal,
        });
        totalPaid += subtotal;
      }
    });

    return { summaryItems, totalPaid };
  };

  // Helper to handle tab switching with sync and reset
  const handleTicketTabSelect = (key) => {
    setActiveTab(key);
    if (key !== "buyer") {
      setActiveTicketId(key);
      setActiveAttendee(0);
      setActiveGuest(0);
    }
  };

  return (
    <>
      <ToastMessage />
      <div
        className={`extraspace_search_div1 add_attendites_model search_div${
          show ? " open" : ""
        }`}
        style={{
          display: show ? "block" : "none",
        }}
      >
        <div
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "#ffffff",
            boxShadow: "-4px 0 20px rgba(0, 0, 0, 0.15)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            style={{
              background: "#184778",
              padding: "20px 25px",
              color: "#ffffff",
              borderBottom: "1px solid #31719c",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}>
                  Add Attendee
                </h3>
                <p
                  style={{
                    margin: "5px 0 0 0",
                    fontSize: "14px",
                    opacity: 0.9,
                  }}
                >
                  Create new attendees for your event
                </p>
              </div>
              <button
                onClick={onHide}
                style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  border: "none",
                  borderRadius: "6px",
                  color: "#ffffff",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                <FaTimes />
              </button>
            </div>
          </div>

          {/* Progress Steps */}
          <div
            style={{
              background: "#f8f9fa",
              padding: "15px 25px",
              borderBottom: "1px solid #e9ecef",
            }}
          >
            <div
              style={{ display: "flex", justifyContent: "center", gap: "8px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: "500",
                  background:
                    step === "options" || step === "tickets"
                      ? "#184778"
                      : "#e9ecef",
                  color:
                    step === "options" || step === "tickets"
                      ? "#ffffff"
                      : "#6c757d",
                }}
              >
                <FaTicketAlt size={12} />
                Tickets
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: "500",
                  background: step === "attendees" ? "#31719c" : "#e9ecef",
                  color: step === "attendees" ? "#ffffff" : "#6c757d",
                }}
              >
                <FaUser size={12} />
                Attendees
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: "500",
                  background: step === "summary" ? "#184778" : "#e9ecef",
                  color: step === "summary" ? "#ffffff" : "#6c757d",
                }}
              >
                Summary
              </div>
            </div>
          </div>

          {/* Content */}
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "25px",
            }}
          >
          {step === "options" && (
  <div>
    <h5
      style={{
        fontSize: "18px",
        fontWeight: "600",
        color: "#184778",
        marginBottom: "20px",
      }}
    >
      Choose an option
    </h5>
    <div
      onClick={() => setSelectedOption("create")}
      style={{
        border: selectedOption === "create" ? "2px solid #184778" : "2px solid #e9ecef",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "15px",
        cursor: "pointer",
        background: selectedOption === "create" ? "#f8f9ff" : "#ffffff",
        transition: "all 0.2s ease",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
        }}
      >
        <div className="attendies_icon_div">
          <FaPlus />
        </div>
        <div style={{ flex: 1 }}>
          <h6
            style={{
              margin: "0 0 0px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#184778",
            }}
          >
            Create an attendee
          </h6>
          <p
            style={{
              margin: 0,
              fontSize: "14px",
              color: "#6c757d",
            }}
          >
            Add attendee with payment received in advance
          </p>
        </div>
        {selectedOption === "create" && (
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              background: "#184778",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            ✓
          </div>
        )}
      </div>
    </div>
    
    <div
      onClick={() => setSelectedOption("import")}
      style={{
        border: selectedOption === "import" ? "2px solid #184778" : "2px solid #e9ecef",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "15px",
        cursor: "pointer",
        background: selectedOption === "import" ? "#f8f9ff" : "#ffffff",
        transition: "all 0.2s ease",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
        }}
      >
        <div className="attendies_icon_div">
          <FaDownload />
        </div>
        <div style={{ flex: 1 }}>
          <h6
            style={{
              margin: "0 0 0px 0",
              fontSize: "16px",
              fontWeight: "600",
              color: "#184778",
            }}
          >
            Import attendees
          </h6>
          <p
            style={{
              margin: 0,
              fontSize: "14px",
              color: "#6c757d",
            }}
          >
            Import attendees from an excel sheet
          </p>
        </div>
        {selectedOption === "import" && (
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              background: "#184778",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            ✓
          </div>
        )}
      </div>
    </div>

    {selectedOption === "import" && (
      <div
        style={{
          padding: "15px",
          background: "#f8f9fa",
          borderRadius: "8px",
          border: "1px solid #e9ecef",
        }}
      >
        <p
          style={{
            margin: "0 0 10px 0",
            fontSize: "14px",
            color: "#495057",
            fontWeight: "500",
          }}
        >
          Need a template? Download our sample spreadsheet to get started.
        </p>
        <button onClick={handleDownloadTemplate}   style={{
                   display: "inline-flex",
                   alignItems: "center",
                   gap: "8px",
                   padding: "10px 16px",
                   background: "#184778",
                   color: "#ffffff",
                   textDecoration: "none",
                   borderRadius: "6px",
                   fontSize: "14px",
                   fontWeight: "500",
                 }}>
                              <FaDownload style={{ fontSize: "12px" }} />  Download Sample Template
                              </button> 
       
        <p
          style={{
            margin: "10px 0 0 0",
            fontSize: "12px",
            color: "#6c757d",
            fontStyle: "italic",
          }}
        >
          {/* Template includes three columns: ticket Name, Email, and Ticket Price */}
        </p>
      </div>
    )}
  </div>
)}

            {step === "tickets" && (
              <div>
                <h5
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#184778",
                    marginBottom: "15px",
                  }}
                >
                  Add Tickets
                </h5>

                <Alert
                  variant="info"
                  style={{
                    background: "#e3f2fd",
                    border: "1px solid #bbdefb",
                    borderRadius: "8px",
                    padding: "12px 15px",
                    marginBottom: "20px",
                    fontSize: "14px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FaInfoCircle />
                    <span>
                      Select the tickets you want to add. You can add multiple
                      tickets for different attendees.
                    </span>
                  </div>
                </Alert>

                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {ticketList
                    .filter((ticket) => ticket.ticket_status === "onsale")
                    .map((ticket) => (
                      <div
                        key={ticket.id}
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          padding: "15px",
                          marginBottom: "12px",
                          background: "#ffffff",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <div className="add_ticket_heading">
                            <h6>{ticket.ticket_name}</h6>
                            <p>{ticket.description}</p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#184778",
                              }}
                            >
                              {ticket.currency}{" "}
                              {Number.parseFloat(
                                ticket.price || 0
                              ).toLocaleString()}
                              {getTaxLabel(
                                ticket.tax_type,
                                ticket.tax_options,
                                settingsDetails
                              )}
                            </span>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                border: "1px solid #31719c",
                                borderRadius: "10px",
                                padding: "4px 8px",
                              }}
                            >
                              <button
                                type="button"
                                onClick={() =>
                                  handleDecreaseQuantity(ticket.id)
                                }
                                disabled={
                                  (selectedTickets[ticket.id] || 0) === 0
                                }
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  border: "none",
                                  background: "transparent",
                                  color: "#31719c",
                                  cursor:
                                    (selectedTickets[ticket.id] || 0) === 0
                                      ? "not-allowed"
                                      : "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <FaMinus size={10} />
                              </button>
                              <span
                                style={{
                                  minWidth: "20px",
                                  textAlign: "center",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                }}
                              >
                                {selectedTickets[ticket.id] || 0}
                              </span>
                              <button
                                type="button"
                                onClick={() =>
                                  handleIncreaseQuantity(ticket.id)
                                }
                                disabled={
                                  (selectedTickets[ticket.id] || 0) >=
                                  ticket.quantity
                                }
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  border: "none",
                                  background: "transparent",
                                  color: "#31719c",
                                  cursor:
                                    (selectedTickets[ticket.id] || 0) >=
                                    ticket.quantity
                                      ? "not-allowed"
                                      : "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <FaPlus size={10} />
                              </button>
                            </div>
                          </div>
                        </div>
                        {ticket.guest_details && (
                          <div
                            style={{
                              marginTop: "10px",
                              paddingTop: "10px",
                              borderTop: "1px solid #f1f3f4",
                            }}
                          >
                            <p
                              style={{
                                margin: "0 0 8px 0",
                                fontSize: "13px",
                                color: "#6c757d",
                              }}
                            >
                              Guests: {guestCounts[ticket.id] || 0} /{" "}
                              {ticket.guest_details.quantity || 0}
                            </p>
                            <button
                              type="button"
                              onClick={() => handleAddGuests(ticket.id)}
                              disabled={
                                (guestCounts[ticket.id] || 0) >=
                                (ticket.guest_details.quantity || 0)
                              }
                              style={{
                                background: "#f8f9fa",
                                border: "1px solid rgb(24 71 120)",
                                borderRadius: "6px",
                                color: "rgb(24 71 120)",
                                padding: "6px 12px",
                                fontSize: "13px",
                                cursor:
                                  (guestCounts[ticket.id] || 0) >=
                                  (ticket.guest_details.quantity || 0)
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            >
                              Add Guest
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            )}

            {step === "attendees" && (
              <div>
                {shouldShowBuyerForm() && totalAttendees > 1 && (
                  <Nav
                    variant="tabs"
                    activeKey={activeTab}
                    onSelect={handleTicketTabSelect}
                    className="mb-3 top_attendies_nav"
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="buyer">Buyer Details</Nav.Link>
                    </Nav.Item>
                    {Object.keys(selectedTickets).map((ticketId) => {
                      const ticket = ticketList.find(
                        (t) => t.id === Number.parseInt(ticketId)
                      );
                      return (
                        <Nav.Item key={ticketId}>
                          <Nav.Link eventKey={ticketId}>
                            {ticket?.ticket_name || `Ticket ${ticketId}`}
                          </Nav.Link>
                        </Nav.Item>
                      );
                    })}
                  </Nav>
                )}

                {activeTab === "buyer" ? (
                  <div
                    style={{
                      background: "#ffffff",
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      padding: "20px",
                    }}
                  >
                    <h6
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#31719c",
                        marginBottom: "15px",
                      }}
                    >
                      Buyer Details
                    </h6>
                    {buyerFormFields.map((field) => (
                      <FormField
                        key={field.id}
                        field={field}
                        value={buyerDetails.customFields?.[field.id] || ""}
                        onChange={(value) => handleBuyerChange(field.id, value)}
                        error={errors[`${field.id}_buyer`]}
                      />
                    ))}
                  </div>
                ) : (
                  <div>
                    {Object.keys(attendeesByTicket).length > 0 &&
                    activeTicketId ? (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "15px",
                            padding: "15px",
                            background:
                              "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                            borderRadius: "8px",
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              background: "#31719c",
                              color: "#ffffff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "16px",
                            }}
                          >
                            <FaUser />
                          </div>
                          <div>
                            <h6
                              style={{
                                margin: "0 0 2px 0",
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#184778",
                              }}
                            >
                              Attendee Details
                            </h6>
                            <p
                              style={{
                                margin: 0,
                                fontSize: "14px",
                                color: "#6c757d",
                              }}
                            >
                              for{" "}
                              {(() => {
                                const ticket = ticketList.find(
                                  (t) =>
                                    t.id === Number.parseInt(activeTicketId)
                                );
                                return ticket
                                  ? ticket.ticket_name
                                  : "Selected Ticket";
                              })()}
                            </p>
                          </div>
                        </div>
                        <Nav
                          variant="tabs"
                          activeKey={activeAttendee}
                          onSelect={(index) =>
                            setActiveAttendee(Number.parseInt(index))
                          }
                          style={{ marginBottom: "15px" }}
                          className="inner_tab_attendies"
                        >
                          {attendeesByTicket[activeTicketId]?.map(
                            (_, index) => (
                              <Nav.Item key={index}>
                                <Nav.Link
                                  eventKey={index}
                                  style={{
                                    color:
                                      activeAttendee === index
                                        ? "#ffffffff"
                                        : "#6c757d",
                                    borderColor:
                                      activeAttendee === index
                                        ? "#184778"
                                        : "transparent",
                                    backgroundColor:
                                      activeAttendee === index
                                        ? "#184778"
                                        : "transparent",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Attendee {index + 1}
                                </Nav.Link>
                              </Nav.Item>
                            )
                          )}
                        </Nav>

                        <div
                          style={{
                            background: "#ffffff",
                            border: "1px solid #e9ecef",
                            borderRadius: "8px",
                            padding: "20px",
                          }}
                        >
                          {(() => {
                            if (!ticketList || !activeTicketId) {
                              return (
                                <p
                                  style={{
                                    textAlign: "center",
                                    color: "#6c757d",
                                    padding: "20px",
                                  }}
                                >
                                  No ticket selected.
                                </p>
                              );
                            }
                            const ticket = ticketList.find(
                              (t) => t.id === Number.parseInt(activeTicketId)
                            );
                            if (!ticket) {
                              return (
                                <p
                                  style={{
                                    textAlign: "center",
                                    color: "#6c757d",
                                    padding: "20px",
                                  }}
                                >
                                  No ticket details available.
                                </p>
                              );
                            }
                            const formDetails = parseFormDetails(
                              ticket.form_details
                            );
                            if (formDetails.length === 0) {
                              return (
                                <p
                                  style={{
                                    textAlign: "center",
                                    color: "#6c757d",
                                    padding: "20px",
                                  }}
                                >
                                  No attendee form fields available.
                                </p>
                              );
                            }
                            return (
                              <>
                                {formDetails.map((field) => (
                                  <FormField
                                    key={`${field.id}_${activeTicketId}_${activeAttendee}`}
                                    field={field}
                                    value={
                                      attendeesByTicket[activeTicketId][
                                        activeAttendee
                                      ].customFields?.[field.id] || ""
                                    }
                                    onChange={(value) =>
                                      handleAttendeeChange(
                                        activeTicketId,
                                        activeAttendee,
                                        field.id,
                                        value
                                      )
                                    }
                                    error={
                                      errors[
                                        `${field.id}_${activeTicketId}_${activeAttendee}_attendee`
                                      ]
                                    }
                                  />
                                ))}
                                {ticket.addons && ticket.addons.length > 0 && (
                                  <div style={{ marginTop: "20px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        marginBottom: "15px",
                                        padding: "15px",
                                        background:
                                          "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                                        borderRadius: "8px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                          borderRadius: "50%",
                                          background: "#31719c",
                                          color: "#ffffff",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          fontSize: "16px",
                                        }}
                                      >
                                        <FaTicketAlt />
                                      </div>
                                      <div>
                                        <h6
                                          style={{
                                            margin: "0 0 2px 0",
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            color: "#184778",
                                          }}
                                        >
                                          Choose Add-ons
                                        </h6>
                                        <p
                                          style={{
                                            margin: 0,
                                            fontSize: "14px",
                                            color: "#6c757d",
                                          }}
                                        >
                                          for Attendee {activeAttendee + 1}
                                        </p>
                                      </div>
                                    </div>
                                    {ticket.addons
                                      .filter(
                                        (ticket) =>
                                          ticket.addon_status === "onsale"
                                      )
                                      .map((addon) => (
                                        <div
                                          key={addon.id}
                                          style={{
                                            border: "1px solid #e9ecef",
                                            borderRadius: "8px",
                                            padding: "15px",
                                            marginBottom: "12px",
                                            background: "#ffffff",
                                          }}
                                        >
                                          <div style={{ marginBottom: "10px" }}>
                                            <h6
                                              style={{
                                                margin: "0 0 5px 0",
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                color: "#184778",
                                              }}
                                            >
                                              {addon.add_on_name}
                                            </h6>
                                            <p
                                              style={{
                                                margin: 0,
                                                fontSize: "13px",
                                                color: "#6c757d",
                                              }}
                                            >
                                              {addon.description}
                                            </p>
                                          </div>
                                          {addon.variant_options &&
                                          addon.variant_options.length > 0 ? (
                                            addon.variant_options.map(
                                              (variant) => {
                                                const currentAddOn =
                                                  attendeesByTicket[
                                                    activeTicketId
                                                  ][activeAttendee].addOns.find(
                                                    (a) =>
                                                      a.id === addon.id &&
                                                      a.variant ===
                                                        variant["variant_name"]
                                                  );
                                                const quantity = currentAddOn
                                                  ? currentAddOn.quantity
                                                  : 0;
                                                let variantTaxPercentage = 0;
                                                if (
                                                  addon.tax_type ===
                                                    "Excluding Tax" &&
                                                  addon.tax_options
                                                ) {
                                                  if (
                                                    settingsDetails?.state_is_same ===
                                                    "no"
                                                  ) {
                                                    const igstTax =
                                                      addon.tax_options.find(
                                                        (tax) =>
                                                          tax.tax_name ===
                                                          "IGST"
                                                      );
                                                    if (igstTax) {
                                                      variantTaxPercentage =
                                                        Number.parseFloat(
                                                          igstTax.tax_percentage ||
                                                            0
                                                        );
                                                    }
                                                  } else {
                                                    const nonIgstTaxes =
                                                      addon.tax_options.filter(
                                                        (tax) =>
                                                          tax.tax_name !==
                                                          "IGST"
                                                      );
                                                    variantTaxPercentage =
                                                      nonIgstTaxes.reduce(
                                                        (sum, tax) =>
                                                          sum +
                                                          Number.parseFloat(
                                                            tax.tax_percentage ||
                                                              0
                                                          ),
                                                        0
                                                      );
                                                  }
                                                } else {
                                                  variantTaxPercentage = 0;
                                                }
                                                const variantPaidPrice =
                                                  getPaidPrice(
                                                    Number.parseFloat(
                                                      variant[
                                                        "variant_price"
                                                      ] || 0
                                                    ),
                                                    addon.tax_type,
                                                    variantTaxPercentage
                                                  );
                                                return (
                                                  <div
                                                    key={
                                                      variant["variant_name"]
                                                    }
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      alignItems: "center",
                                                      padding: "10px 0",
                                                      borderTop:
                                                        "1px solid #f1f3f4",
                                                    }}
                                                  >
                                                    <div>
                                                      <span
                                                        style={{
                                                          fontSize: "14px",
                                                          fontWeight: "500",
                                                          color: "#184778",
                                                        }}
                                                      >
                                                        {
                                                          variant[
                                                            "variant_name"
                                                          ]
                                                        }{" "}
                                                        - {addon.currency}{" "}
                                                        {variantPaidPrice.toLocaleString()}
                                                      </span>
                                                      <br />
                                                      <small
                                                        style={{
                                                          color: "#6c757d",
                                                        }}
                                                      >
                                                        (
                                                        {
                                                          variant[
                                                            "quantity_available"
                                                          ]
                                                        }{" "}
                                                        available)
                                                      </small>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          handleAddOnQuantityChange(
                                                            activeTicketId,
                                                            activeAttendee,
                                                            addon.id,
                                                            variant[
                                                              "variant_name"
                                                            ],
                                                            -1
                                                          )
                                                        }
                                                        disabled={
                                                          quantity === 0
                                                        }
                                                        style={{
                                                          width: "28px",
                                                          height: "28px",
                                                          border:
                                                            "1px solid #31719c",
                                                          background: "#ffffff",
                                                          color: "#31719c",
                                                          borderRadius: "4px",
                                                          cursor: "pointer",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          justifyContent:
                                                            "center",
                                                        }}
                                                      >
                                                        <FaMinus size={10} />
                                                      </button>
                                                      <span
                                                        style={{
                                                          minWidth: "30px",
                                                          textAlign: "center",
                                                          fontSize: "14px",
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {quantity}
                                                      </span>
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          handleAddOnQuantityChange(
                                                            activeTicketId,
                                                            activeAttendee,
                                                            addon.id,
                                                            variant[
                                                              "variant_name"
                                                            ],
                                                            1
                                                          )
                                                        }
                                                        disabled={
                                                          quantity >=
                                                            variant[
                                                              "quantity_available"
                                                            ] ||
                                                          addon.addon_status ===
                                                            "paused"
                                                        }
                                                        style={{
                                                          width: "28px",
                                                          height: "28px",
                                                          border:
                                                            "1px solid #31719c",
                                                          background: "#31719c",
                                                          color: "#ffffff",
                                                          borderRadius: "4px",
                                                          cursor: "pointer",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          justifyContent:
                                                            "center",
                                                        }}
                                                      >
                                                        <FaPlus size={10} />
                                                      </button>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )
                                          ) : (
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: "10px 0",
                                              }}
                                            >
                                              <div>
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    color: "#184778",
                                                  }}
                                                >
                                                  {addon.add_on_name} -{" "}
                                                  {addon.currency}{" "}
                                                  {Number.parseFloat(
                                                    addon.price || 0
                                                  ).toLocaleString()}
                                                </span>
                                                <br />
                                                <small
                                                  style={{ color: "#6c757d" }}
                                                >
                                                  ({addon.quantity} available)
                                                </small>
                                              </div>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                }}
                                              >
                                                <button
                                                  type="button"
                                                  onClick={() =>
                                                    handleAddOnQuantityChange(
                                                      activeTicketId,
                                                      activeAttendee,
                                                      addon.id,
                                                      null,
                                                      -1
                                                    )
                                                  }
                                                  disabled={
                                                    !attendeesByTicket[
                                                      activeTicketId
                                                    ][
                                                      activeAttendee
                                                    ].addOns.find(
                                                      (a) =>
                                                        a.id === addon.id &&
                                                        !a.variant
                                                    )
                                                  }
                                                  style={{
                                                    width: "28px",
                                                    height: "28px",
                                                    border: "1px solid #31719c",
                                                    background: "#ffffff",
                                                    color: "#31719c",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <FaMinus size={10} />
                                                </button>
                                                <span
                                                  style={{
                                                    minWidth: "30px",
                                                    textAlign: "center",
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                  }}
                                                >
                                                  {attendeesByTicket[
                                                    activeTicketId
                                                  ][activeAttendee].addOns.find(
                                                    (a) =>
                                                      a.id === addon.id &&
                                                      !a.variant
                                                  )?.quantity || 0}
                                                </span>
                                                <button
                                                  type="button"
                                                  onClick={() =>
                                                    handleAddOnQuantityChange(
                                                      activeTicketId,
                                                      activeAttendee,
                                                      addon.id,
                                                      null,
                                                      1
                                                    )
                                                  }
                                                  disabled={
                                                    (attendeesByTicket[
                                                      activeTicketId
                                                    ][
                                                      activeAttendee
                                                    ].addOns.find(
                                                      (a) =>
                                                        a.id === addon.id &&
                                                        !a.variant
                                                    )?.quantity || 0) >=
                                                      addon.quantity ||
                                                    addon.addon_status ===
                                                      "paused"
                                                  }
                                                  style={{
                                                    width: "28px",
                                                    height: "28px",
                                                    border: "1px solid #31719c",
                                                    background: "#31719c",
                                                    color: "#ffffff",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <FaPlus size={10} />
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                  </div>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </>
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          color: "#6c757d",
                          padding: "40px",
                        }}
                      >
                        No attendees available for this ticket.
                      </p>
                    )}

                    {(guestCounts[activeTicketId] || 0) > 0 && (
                      <>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#184778",
                            marginBottom: "10px",
                            marginTop: "10px",
                          }}
                        >
                          Guests
                        </h6>
                        <Nav
                          variant="tabs"
                          className="guest_tab_inner"
                          activeKey={activeGuest}
                          onSelect={(index) =>
                            setActiveGuest(Number.parseInt(index))
                          }
                          style={{ marginBottom: "15px" }}
                        >
                          {guestsByTicket[activeTicketId].map((_, index) => (
                            <Nav.Item key={index}>
                              <Nav.Link
                                eventKey={index}
                                style={{
                                  color:
                                    activeGuest === index
                                      ? "#184778"
                                      : "#6c757d",
                                  borderColor:
                                    activeGuest === index
                                      ? "#184778"
                                      : "transparent",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                }}
                              >
                                Guest {index + 1}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                        </Nav>

                        <div
                          style={{
                            background: "#ffffff",
                            border: "1px solid #e9ecef",
                            borderRadius: "8px",
                            padding: "20px",
                          }}
                        >
                          {(() => {
                            if (!ticketList || !activeTicketId) {
                              return (
                                <p
                                  style={{
                                    textAlign: "center",
                                    color: "#6c757d",
                                    padding: "20px",
                                  }}
                                >
                                  No ticket selected.
                                </p>
                              );
                            }
                            const ticket = ticketList.find(
                              (t) => t.id === Number.parseInt(activeTicketId)
                            );
                            if (!ticket || !ticket.guest_details) {
                              return (
                                <p
                                  style={{
                                    textAlign: "center",
                                    color: "#6c757d",
                                    padding: "20px",
                                  }}
                                >
                                  No guest details available.
                                </p>
                              );
                            }
                            const formDetails = parseFormDetails(
                              ticket.guest_details.form_details
                            );
                            if (formDetails.length === 0) {
                              return (
                                <p
                                  style={{
                                    textAlign: "center",
                                    color: "#6c757d",
                                    padding: "20px",
                                  }}
                                >
                                  No guest form fields available.
                                </p>
                              );
                            }
                            const attendeeFormDetails = parseFormDetails(
                              ticket.form_details
                            );
                            const firstNameField = attendeeFormDetails.find(
                              (f) => f.name === "first_name"
                            );
                            const lastNameField = attendeeFormDetails.find(
                              (f) => f.name === "last_name"
                            );
                            const attendees =
                              attendeesByTicket[activeTicketId] || [];
                            const attendeeOptions = attendees.map(
                              (att, index) => {
                                const first = firstNameField
                                  ? att.customFields[firstNameField.id]
                                  : "";
                                const last = lastNameField
                                  ? att.customFields[lastNameField.id]
                                  : "";
                                const fullName =
                                  `${first} ${last}`.trim() ||
                                  `Attendee ${index + 1}`;
                                return { value: index, label: fullName };
                              }
                            );
                            return (
                              <>
                                {formDetails.map((field) => (
                                  <FormField
                                    key={`${field.id}_${activeTicketId}_${activeGuest}`}
                                    field={field}
                                    value={
                                      guestsByTicket[activeTicketId][
                                        activeGuest
                                      ].customFields?.[field.id] || ""
                                    }
                                    onChange={(value) =>
                                      handleGuestChange(
                                        activeTicketId,
                                        activeGuest,
                                        field.id,
                                        value
                                      )
                                    }
                                    error={
                                      errors[
                                        `${field.id}_${activeTicketId}_${activeGuest}_guest`
                                      ]
                                    }
                                  />
                                ))}
                                <div style={{ marginBottom: "15px" }}>
                                  <label
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      marginBottom: "8px",
                                      display: "block",
                                    }}
                                  >
                                    Assign to Attendee
                                  </label>
                                  <Form.Control
                                    as="select"
                                    value={
                                      guestsByTicket[activeTicketId][
                                        activeGuest
                                      ].assignedAttendee ?? ""
                                    }
                                    onChange={(e) =>
                                      handleGuestAssignChange(
                                        activeTicketId,
                                        activeGuest,
                                        e.target.value
                                      )
                                    }
                                    style={{
                                      padding: "10px 12px",
                                      border: "1px solid #ced4da",
                                      borderRadius: "6px",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <option value="">Select Attendee</option>
                                    {attendeeOptions.map((option) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </div>
                                {ticket.guest_details.addons &&
                                  ticket.guest_details.addons.length > 0 && (
                                    <div style={{ marginTop: "20px" }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "12px",
                                          marginBottom: "15px",
                                          padding: "15px",
                                          background:
                                            "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                            background: "#184778",
                                            color: "#ffffff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <FaTicketAlt />
                                        </div>
                                        <div>
                                          <h6
                                            style={{
                                              margin: "0 0 2px 0",
                                              fontSize: "16px",
                                              fontWeight: "600",
                                              color: "#184778",
                                            }}
                                          >
                                            Choose Add-ons
                                          </h6>
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: "14px",
                                              color: "#6c757d",
                                            }}
                                          >
                                            for Guest {activeGuest + 1}
                                          </p>
                                        </div>
                                      </div>
                                      {ticket.guest_details.addons
                                        .filter(
                                          (ticket) =>
                                            ticket.addon_status === "onsale"
                                        )
                                        .map((addon) => (
                                          <div
                                            key={addon.id}
                                            style={{
                                              border: "1px solid #e9ecef",
                                              borderRadius: "8px",
                                              padding: "15px",
                                              marginBottom: "12px",
                                              background: "#ffffff",
                                            }}
                                          >
                                            <div
                                              style={{ marginBottom: "10px" }}
                                            >
                                              <h6
                                                style={{
                                                  margin: "0 0 5px 0",
                                                  fontSize: "15px",
                                                  fontWeight: "600",
                                                  color: "#184778",
                                                }}
                                              >
                                                {addon.add_on_name}
                                              </h6>
                                              <p
                                                style={{
                                                  margin: 0,
                                                  fontSize: "13px",
                                                  color: "#6c757d",
                                                }}
                                              >
                                                {addon.description}
                                              </p>
                                            </div>
                                            {addon.variant_options &&
                                            addon.variant_options.length > 0 ? (
                                              addon.variant_options.map(
                                                (variant) => {
                                                  const currentAddOn =
                                                    guestsByTicket[
                                                      activeTicketId
                                                    ][activeGuest].addOns.find(
                                                      (a) =>
                                                        a.id === addon.id &&
                                                        a.variant ===
                                                          variant[
                                                            "variant_name"
                                                          ]
                                                    );
                                                  const quantity = currentAddOn
                                                    ? currentAddOn.quantity
                                                    : 0;
                                                  let variantTaxPercentage = 0;
                                                  if (
                                                    addon.tax_type ===
                                                      "Excluding Tax" &&
                                                    addon.tax_options
                                                  ) {
                                                    if (
                                                      settingsDetails?.state_is_same ===
                                                      "no"
                                                    ) {
                                                      const igstTax =
                                                        addon.tax_options.find(
                                                          (tax) =>
                                                            tax.tax_name ===
                                                            "IGST"
                                                        );
                                                      if (igstTax) {
                                                        variantTaxPercentage =
                                                          Number.parseFloat(
                                                            igstTax.tax_percentage ||
                                                              0
                                                          );
                                                      }
                                                    } else {
                                                      const nonIgstTaxes =
                                                        addon.tax_options.filter(
                                                          (tax) =>
                                                            tax.tax_name !==
                                                            "IGST"
                                                        );
                                                      variantTaxPercentage =
                                                        nonIgstTaxes.reduce(
                                                          (sum, tax) =>
                                                            sum +
                                                            Number.parseFloat(
                                                              tax.tax_percentage ||
                                                                0
                                                            ),
                                                          0
                                                        );
                                                    }
                                                  } else {
                                                    variantTaxPercentage = 0;
                                                  }
                                                  return (
                                                    <div
                                                      key={
                                                        variant["variant_name"]
                                                      }
                                                      style={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                        padding: "10px 0",
                                                        borderTop:
                                                          "1px solid #f1f3f4",
                                                      }}
                                                    >
                                                      <div>
                                                        <span
                                                          style={{
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                            color: "#184778",
                                                          }}
                                                        >
                                                          {
                                                            variant[
                                                              "variant_name"
                                                            ]
                                                          }{" "}
                                                          - {addon.currency}{" "}
                                                          {Number.parseFloat(
                                                            variant[
                                                              "variant_price"
                                                            ]
                                                          ).toLocaleString()}
                                                        </span>
                                                        <br />
                                                        <small
                                                          style={{
                                                            color: "#6c757d",
                                                          }}
                                                        >
                                                          (
                                                          {
                                                            variant[
                                                              "quantity_available"
                                                            ]
                                                          }{" "}
                                                          available)
                                                        </small>
                                                      </div>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "8px",
                                                        }}
                                                      >
                                                        <button
                                                          type="button"
                                                          onClick={() =>
                                                            handleGuestAddOnQuantityChange(
                                                              activeTicketId,
                                                              activeGuest,
                                                              addon.id,
                                                              variant[
                                                                "variant_name"
                                                              ],
                                                              -1
                                                            )
                                                          }
                                                          disabled={
                                                            quantity === 0
                                                          }
                                                          style={{
                                                            width: "28px",
                                                            height: "28px",
                                                            border:
                                                              "1px solid #184778",
                                                            background:
                                                              "#ffffff",
                                                            color: "#184778",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            justifyContent:
                                                              "center",
                                                          }}
                                                        >
                                                          <FaMinus size={10} />
                                                        </button>
                                                        <span
                                                          style={{
                                                            minWidth: "30px",
                                                            textAlign: "center",
                                                            fontSize: "14px",
                                                            fontWeight: "600",
                                                          }}
                                                        >
                                                          {quantity}
                                                        </span>
                                                        <button
                                                          type="button"
                                                          onClick={() =>
                                                            handleGuestAddOnQuantityChange(
                                                              activeTicketId,
                                                              activeGuest,
                                                              addon.id,
                                                              variant[
                                                                "variant_name"
                                                              ],
                                                              1
                                                            )
                                                          }
                                                          disabled={
                                                            quantity >=
                                                              variant[
                                                                "quantity_available"
                                                              ] ||
                                                            addon.addon_status ===
                                                              "paused"
                                                          }
                                                          style={{
                                                            width: "28px",
                                                            height: "28px",
                                                            border:
                                                              "1px solid #184778",
                                                            background:
                                                              "#184778",
                                                            color: "#ffffff",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            justifyContent:
                                                              "center",
                                                          }}
                                                        >
                                                          <FaPlus size={10} />
                                                        </button>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )
                                            ) : (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "center",
                                                  padding: "10px 0",
                                                }}
                                              >
                                                <div>
                                                  <span
                                                    style={{
                                                      fontSize: "14px",
                                                      fontWeight: "500",
                                                      color: "#184778",
                                                    }}
                                                  >
                                                    {addon.add_on_name} -{" "}
                                                    {addon.currency}{" "}
                                                    {Number.parseFloat(
                                                      addon.price || 0
                                                    ).toLocaleString()}
                                                  </span>
                                                  <br />
                                                  <small
                                                    style={{ color: "#6c757d" }}
                                                  >
                                                    ({addon.quantity} available)
                                                  </small>
                                                </div>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                  }}
                                                >
                                                  <button
                                                    type="button"
                                                    onClick={() =>
                                                      handleGuestAddOnQuantityChange(
                                                        activeTicketId,
                                                        activeGuest,
                                                        addon.id,
                                                        null,
                                                        -1
                                                      )
                                                    }
                                                    disabled={
                                                      !guestsByTicket[
                                                        activeTicketId
                                                      ][
                                                        activeGuest
                                                      ].addOns.find(
                                                        (a) =>
                                                          a.id === addon.id &&
                                                          !a.variant
                                                      )
                                                    }
                                                    style={{
                                                      width: "28px",
                                                      height: "28px",
                                                      border:
                                                        "1px solid #184778",
                                                      background: "#ffffff",
                                                      color: "#184778",
                                                      borderRadius: "4px",
                                                      cursor: "pointer",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <FaMinus size={10} />
                                                  </button>
                                                  <span
                                                    style={{
                                                      minWidth: "30px",
                                                      textAlign: "center",
                                                      fontSize: "14px",
                                                      fontWeight: "600",
                                                    }}
                                                  >
                                                    {guestsByTicket[
                                                      activeTicketId
                                                    ][activeGuest].addOns.find(
                                                      (a) =>
                                                        a.id === addon.id &&
                                                        !a.variant
                                                    )?.quantity || 0}
                                                  </span>
                                                  <button
                                                    type="button"
                                                    onClick={() =>
                                                      handleGuestAddOnQuantityChange(
                                                        activeTicketId,
                                                        activeGuest,
                                                        addon.id,
                                                        null,
                                                        1
                                                      )
                                                    }
                                                    disabled={
                                                      (guestsByTicket[
                                                        activeTicketId
                                                      ][
                                                        activeGuest
                                                      ].addOns.find(
                                                        (a) =>
                                                          a.id === addon.id &&
                                                          !a.variant
                                                      )?.quantity || 0) >=
                                                        addon.quantity ||
                                                      addon.addon_status ===
                                                        "paused"
                                                    }
                                                    style={{
                                                      width: "28px",
                                                      height: "28px",
                                                      border:
                                                        "1px solid #184778",
                                                      background: "#184778",
                                                      color: "#ffffff",
                                                      borderRadius: "4px",
                                                      cursor: "pointer",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <FaPlus size={10} />
                                                  </button>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  )}
                              </>
                            );
                          })()}
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            )}

            {step === "summary" && (
              <div>
                <h5
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#184778",
                    marginBottom: "20px",
                  }}
                >
                  Order Summary
                </h5>
                {/* Enhanced Order Summary to show tax breakdown */}
                <div
                  style={{
                    background: "#ffffff",
                    border: "1px solid #e9ecef",
                    borderRadius: "8px",
                    padding: "20px",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ marginBottom: "15px" }}>
                    <div
                      style={{
                        display: "flex",
                        fontWeight: "600",
                        fontSize: "14px",
                        color: "#184778",
                        borderBottom: "2px solid #f1f3f4",
                        paddingBottom: "10px",
                        marginBottom: "15px",
                      }}
                    >
                      <div style={{ flex: 1 }}>Item</div>
                      <div style={{ width: "80px", textAlign: "right" }}>
                        Base Price
                      </div>
                      <div style={{ width: "60px", textAlign: "center" }}>
                        Qty
                      </div>
                      <div style={{ width: "80px", textAlign: "right" }}>
                        Tax
                      </div>
                      <div style={{ width: "100px", textAlign: "right" }}>
                        Subtotal
                      </div>
                    </div>

                    {calculateSummary().summaryItems.map((item, index) => {
                      const ticket =
                        ticketList.find((t) => t.ticket_name === item.name) ||
                        ticketList.find((t) =>
                          t.addons?.some(
                            (addon) =>
                              addon.add_on_name === item.name.split(" (")[0]
                          )
                        );

                      let taxAmount = 0;
                      let basePrice = item.price;

                      if (
                        ticket &&
                        ticket.tax_type === "Excluding Tax" &&
                        ticket.tax_options
                      ) {
                        let taxPercentage = 0;
                        if (settingsDetails?.state_is_same === "no") {
                          const igstTax = ticket.tax_options.find(
                            (tax) => tax.tax_name === "IGST"
                          );
                          if (igstTax)
                            taxPercentage = Number.parseFloat(
                              igstTax.tax_percentage || 0
                            );
                        } else {
                          const nonIgstTaxes = ticket.tax_options.filter(
                            (tax) => tax.tax_name !== "IGST"
                          );
                          taxPercentage = nonIgstTaxes.reduce(
                            (sum, tax) =>
                              sum + Number.parseFloat(tax.tax_percentage || 0),
                            0
                          );
                        }

                        basePrice = item.price / (1 + taxPercentage / 100);
                        taxAmount = item.price - basePrice;
                      }

                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "8px 0",
                            borderBottom: "1px solid #f8f9fa",
                            fontSize: "14px",
                          }}
                        >
                          <div
                            style={{
                              flex: 1,
                              fontWeight: "500",
                              color: "#184778",
                            }}
                          >
                            {item.name}
                            {ticket &&
                              ticket.tax_type === "Excluding Tax" &&
                              ticket.tax_options && (
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#6c757d",
                                    marginTop: "2px",
                                  }}
                                >
                                  {getTaxLabel(
                                    ticket.tax_type,
                                    ticket.tax_options,
                                    settingsDetails
                                  )}
                                </div>
                              )}
                          </div>
                          <div
                            style={{
                              width: "80px",
                              textAlign: "right",
                              color: "#6c757d",
                            }}
                          >
                            {ticketList[0]?.currency || ""}{" "}
                            {basePrice.toLocaleString()}
                          </div>
                          <div
                            style={{
                              width: "60px",
                              textAlign: "center",
                              fontWeight: "600",
                            }}
                          >
                            {item.quantity}
                          </div>
                          <div
                            style={{
                              width: "80px",
                              textAlign: "right",
                              color: "#dc3545",
                            }}
                          >
                            {taxAmount > 0
                              ? `${ticketList[0]?.currency || ""} ${(
                                  taxAmount * item.quantity
                                ).toLocaleString()}`
                              : "-"}
                          </div>
                          <div
                            style={{
                              width: "100px",
                              textAlign: "right",
                              fontWeight: "600",
                              color: "#184778",
                            }}
                          >
                            {ticketList[0]?.currency || ""}{" "}
                            {item.subtotal.toLocaleString()}
                          </div>
                        </div>
                      );
                    })}

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "12px 0",
                        borderTop: "2px solid #184778",
                        marginTop: "15px",
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#184778",
                      }}
                    >
                      <div style={{ flex: 1 }}>Total</div>
                      <div style={{ width: "100px", textAlign: "right" }}>
                        {ticketList[0]?.currency || ""}{" "}
                        {calculateSummary().totalPaid.toLocaleString()}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    background: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    borderRadius: "8px",
                    padding: "20px",
                    marginBottom: "20px",
                  }}
                >
                  <h6
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#184778",
                      marginBottom: "15px",
                    }}
                  >
                    Payment Information
                  </h6>
                  <div className="row">
                    <div className="col-md-6">
                      <p
                        style={{
                          margin: "0 0 5px 0",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#495057",
                        }}
                      >
                        Payment Method:
                      </p>
                      <p
                        style={{
                          margin: "0 0 15px 0",
                          fontSize: "14px",
                          color: "#6c757d",
                        }}
                      >
                        Cheque
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p
                        style={{
                          margin: "0 0 5px 0",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#495057",
                        }}
                      >
                        Payment Status:
                      </p>
                      <Badge
                        bg="success"
                        style={{
                          background: "#28a745",

                          color: "#ffffff",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          fontSize: "12px",
                        }}
                      >
                        Paid
                      </Badge>
                    </div>
                  </div>
                </div>

                {totalAttendees > 1 && buyerDetails && (
                  <>
                    <h5
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#31719c",
                        marginBottom: "15px",
                      }}
                    >
                      Buyer Summary
                    </h5>
                    <div
                      style={{
                        background: "#ffffff",
                        border: "1px solid #e9ecef",
                        borderRadius: "8px",
                        padding: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <h6
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#184778",
                          marginBottom: "10px",
                        }}
                      >
                        Buyer Details
                      </h6>
                      {buyerDetails.customFields &&
                      Object.keys(buyerDetails.customFields).length > 0 ? (
                        buyerFormFields.map((field) => (
                          <p
                            key={field.id}
                            style={{ margin: "0 0 8px 0", fontSize: "14px" }}
                          >
                            <strong style={{ color: "#495057" }}>
                              {field.label}:
                            </strong>{" "}
                            {field.type === "file" ? (
                              buyerDetails.customFields[field.id] ? (
                                Array.isArray(
                                  buyerDetails.customFields[field.id]
                                ) ? (
                                  buyerDetails.customFields[field.id].map(
                                    (url, index) => (
                                      <img
                                        key={index}
                                        src={url || "/placeholder.svg"}
                                        alt={`Uploaded image ${index + 1}`}
                                        style={{
                                          maxWidth: "100px",
                                          marginRight: "10px",
                                          marginTop: "5px",
                                        }}
                                      />
                                    )
                                  )
                                ) : (
                                  <img
                                    src={
                                      buyerDetails.customFields[field.id] ||
                                      "/placeholder.svg"
                                    }
                                    alt="Uploaded image"
                                    style={{
                                      maxWidth: "100px",
                                      marginTop: "5px",
                                    }}
                                  />
                                )
                              ) : (
                                <span style={{ color: "#6c757d" }}>
                                  No file uploaded
                                </span>
                              )
                            ) : field.type === "password" ? (
                              <span style={{ color: "#6c757d" }}>********</span>
                            ) : (
                              <span style={{ color: "#6c757d" }}>
                                {buyerDetails.customFields[field.id] || "N/A"}
                              </span>
                            )}
                          </p>
                        ))
                      ) : (
                        <p
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            color: "#6c757d",
                            fontStyle: "italic",
                          }}
                        >
                          No buyer details provided.
                        </p>
                      )}
                    </div>
                  </>
                )}

                <h5
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#184778",
                    marginBottom: "15px",
                  }}
                >
                  Attendee Summary
                </h5>
                {Object.keys(attendeesByTicket).map((ticketId) => {
                  const ticket = ticketList.find(
                    (t) => t.id === Number.parseInt(ticketId)
                  );
                  const formDetails = parseFormDetails(ticket?.form_details);
                  return (
                    <div key={ticketId} style={{ marginBottom: "20px" }}>
                      <h6
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#184778",
                          marginBottom: "10px",
                        }}
                      >
                        {ticket.ticket_name}
                      </h6>
                      {attendeesByTicket[ticketId].map((attendee, index) => (
                        <div
                          key={index}
                          style={{
                            background: "#ffffff",
                            border: "1px solid #e9ecef",
                            borderRadius: "8px",
                            padding: "15px",
                            marginBottom: "10px",
                          }}
                        >
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#184778",
                              marginBottom: "8px",
                            }}
                          >
                            Attendee #{index + 1}
                          </h6>
                          {attendee.customFields &&
                            Object.keys(attendee.customFields).length > 0 && (
                              <div>
                                {formDetails.map((field) => (
                                  <p
                                    key={field.id}
                                    style={{
                                      margin: "0 0 5px 0",
                                      fontSize: "13px",
                                    }}
                                  >
                                    <strong style={{ color: "#495057" }}>
                                      {field.label}:
                                    </strong>{" "}
                                    {field.type === "file" ? (
                                      attendee.customFields[field.id] ? (
                                        Array.isArray(
                                          attendee.customFields[field.id]
                                        ) ? (
                                          attendee.customFields[field.id].map(
                                            (url, index) => (
                                              <img
                                                key={index}
                                                src={url || "/placeholder.svg"}
                                                alt={`Uploaded image ${
                                                  index + 1
                                                }`}
                                                style={{
                                                  maxWidth: "100px",
                                                  marginRight: "10px",
                                                  marginTop: "5px",
                                                }}
                                              />
                                            )
                                          )
                                        ) : (
                                          <img
                                            src={
                                              attendee.customFields[field.id] ||
                                              "/placeholder.svg"
                                            }
                                            alt="Uploaded image"
                                            style={{
                                              maxWidth: "100px",
                                              marginTop: "5px",
                                            }}
                                          />
                                        )
                                      ) : (
                                        <span style={{ color: "#6c757d" }}>
                                          No file uploaded
                                        </span>
                                      )
                                    ) : field.type === "password" ? (
                                      <span style={{ color: "#6c757d" }}>
                                        ********
                                      </span>
                                    ) : (
                                      <span style={{ color: "#6c757d" }}>
                                        {attendee.customFields[field.id] ||
                                          "N/A"}
                                      </span>
                                    )}
                                  </p>
                                ))}
                              </div>
                            )}
                          {attendee.addOns.length > 0 && (
                            <p
                              style={{ margin: "5px 0 0 0", fontSize: "13px" }}
                            >
                              <strong style={{ color: "#495057" }}>
                                Add-ons:
                              </strong>{" "}
                              <span style={{ color: "#6c757d" }}>
                                {attendee.addOns
                                  .map((addOn) => {
                                    const ticketAddOns = ticket.addons || [];
                                    const selectedAddOn = ticketAddOns.find(
                                      (a) => a.id === addOn.id
                                    );
                                    return selectedAddOn
                                      ? `${selectedAddOn.add_on_name}${
                                          addOn.variant
                                            ? ` (${addOn.variant}, Qty: ${addOn.quantity})`
                                            : ` (Qty: ${addOn.quantity})`
                                        }`
                                      : "";
                                  })
                                  .filter(Boolean)
                                  .join(", ")}
                              </span>
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Footer */}
          <div
            style={{
              background: "#f8f9fa",
              padding: "20px 25px",
              borderTop: "1px solid #e9ecef",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {step !== "options" && (
              <button
                onClick={handleBack}
                style={{
                  background: "transparent",
                  border: "1px solid #6c757d",
                  borderRadius: "6px",
                  color: "#6c757d",
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                Back
              </button>
            )}
            <div style={{ marginLeft: "auto" }}>
              <button
                onClick={handleContinue}
                disabled={step === "summary" && addAttendeeStatus}
                style={{
                  background: step === "summary" ? "#31719c" : "#184778",
                  border: "none",
                  borderRadius: "6px",
                  color: "#ffffff",
                  padding: "12px 24px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor:
                    step === "summary" && addAttendeeStatus
                      ? "not-allowed"
                      : "pointer",
                  opacity: step === "summary" && addAttendeeStatus ? 0.7 : 1,
                }}
              >
                {step === "summary" && addAttendeeStatus ? (
                  <>
                    <FaSpinner
                      className="fa-spin"
                      style={{ fontSize: "14px", marginRight: "8px" }}
                    />
                    Submitting...
                  </>
                ) : step === "summary" ? (
                  "Submit"
                ) : (
                  "Continue"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

     <ImportModal
  show={showAttendeeImportModal}
  onHide={() => setShowAttendeeImportModal(false)}
  onImportComplete={handleImportComplete}
/>
    </>
  );
};

export default AddAttendeeModal;
